import React, { useState, useEffect } from "react";
import axios from "../../api/axios";
import { toast } from "react-toastify";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Header from "../../layouts/Header";
import {
    Button,
    Col,
    Dropdown,
    Form,
    Modal,
    Row,
    Spinner,
    Table,
    OverlayTrigger,
    Tooltip,
    Card,
    Nav,
    Container,
    Tab,
} from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const PurchaseList = () => {

    const navigate = useNavigate();
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [purchaseAccess, setPurchaseAccess] = useState([]);

    console.log("Access :", access);

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("PurchaseList:"),
            );
            setPurchaseAccess(filteredAccess);
        }
    }, [access]);

    console.log("Menu Access:", purchaseAccess);

    // Add all the state and functions from AddPurchase component here
    const [inputData, setInputData] = useState({
        vendor: "",
        idNumber: "",
        procurementItems: [
            {
                material: "",
                quantity: "",
                rate: "",
                taxPercent: "",
            },
        ],
        charges: [], // Changed from additionalCharges to charges array
    });

    const [validationErrors, setValidationErrors] = useState({
        vendor: "",
        idNumber: "",
        invoiceFile: "",
        procurementItems: [
            {
                material: "",
                quantity: "",
                rate: "",
            },
        ],
        charges: [], // Add validation errors for charges
    });

    const [rawMaterialDetail, setRawMaterialDetail] = useState({});
    const [isPurchaseLoading, setIsPurchaseLoading] = useState(false);
    const [showAddPurchaseModal, setShowAddPurchaseModal] = useState(false);

    const accessToken = localStorage.getItem("authToken");
    const animatedComponents = makeAnimated();
    const [procurementsList, setProcurementsList] = useState([]);
    const [pagination, setPagination] = useState({ page: 1, recordsPerPage: 10 });
    const [openViewModal, setOpenViewModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [singleProcurementDetails, setSingleProcurementDetails] = useState({});
    const [singleProcurementItemsDetails, setSingleProcurementItemsDetails] =
        useState([]);
    const [singleProcurementCharges, setSingleProcurementCharges] = useState([]); // New state for charges
    const [editedData, setEditedData] = useState({});
    const [btnLoading, setBtnLoading] = useState(false);
    const [searchBtnLoading, setSearchBtnLoading] = useState(false);
    const [touched, setTouched] = useState(false);
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [vendors, setVendors] = useState([]);
    const [selectedStorageLocation, setSelectedStorageLocation] = useState("");
    const [selectedOutlet, setSelectedOutlet] = useState("");
    const [outlets, setOutlets] = useState([]);
    const [openAddProcurementItemModal, setOpenAddProcurementItemModal] =
        useState(false);
    const [procurementId, setProcurementId] = useState("");
    const [isAddItemBtnLoading, setIsAddItemBtnLoading] = useState(false);
    const [addProcurementItemDetails, setAddProcurementItemDetails] = useState({
        material: "",
        quantity: "",
        rate: "",
        taxPercent: "",
        taxAmount: "",
        taxable: "",
        grandTotal: "",
        unit: "",
    });
    const [rawMaterialList, setRawMaterialList] = useState([]);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [isStatusBtnLoading, setIsStatusBtnLoading] = useState(false);
    const [openUpdateStatusModal, setOpenUpdateStatusModal] = useState(false);
    const [openProcurementItemEditModal, setOpenProcurementItemEditModal] =
        useState(false);
    const [editProcurementItemDetails, setEditProcurementItemDetails] = useState(
        {},
    );
    const [isEditItemBtnLoading, setIsEditItemBtnLoading] = useState(false);
    const [openProcurementItemDeleteModal, setOpenProcurementDeleteModal] =
        useState(false);
    const [procurementItemIds, setProcurmentItemIds] = useState([]);
    const [isItemDeleteBtnLoading, setIsItemDeleteBtnLoading] = useState(false);
    const [openUpdateStatusItemModal, setOpenUpdateStatusItemModal] =
        useState(false);
    const [itemId, setItemId] = useState([]);
    const [isItemStatusBtnLoading, setIsItemStatusBtnLoading] = useState(false);
    const [invoiceFile, setInvoiceFile] = useState(null);
    const [openEditStatusWithRemarksModal, setOpenEditStatusWithRemarksModal] =
        useState(false);
    const [remark, setRemark] = useState("");
    const [isEditwithRemarkBtnLoading, setIsEditWithRemarkBtnLoading] =
        useState(false);

    const [editValidationErrors, setEditValidationErrors] = useState({
        vendor: "",
        idNumber: "",
        scannedInvoice: "",
    });

    const [validateRemark, setValidateRemark] = useState("");
    const [searchText, setSearchText] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [error, setError] = useState("");
    const [selectedVendor, setSelectedVendor] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [currentPage, setCurrentPage] = useState("1");
    const [recordsPerPage, setRecordsPerPage] = useState("10");
    const [selectedSortBy, setSelectedSortBy] = useState("");
    const [totalRecords, setTotalRecords] = useState("");
    const [storageLocationList, setStorageLocationList] = useState([]);
    const [filterState, setFilterState] = useState("");
    const [filterCity, setFilterCity] = useState("");

    // State For Adding Raw Materials
    const [isLoading, setIsLoading] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [formData, setFormData] = useState({
        mainCategory: "",
        subCategory: "",
        name: "",
        reOrderLevel: "",
        description: "",
        unit: "",
        hsn: "",
        taxPercent: "",
        purchaseUnit: "",
    });
    const [mainCategories, setMainCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [filteredSubCategories, setFilteredSubCategories] = useState([]);

    useEffect(() => {
        getMainCategories();
        getSubCategories();
    }, [showAddModal])

    // Format options for react-select
    const mainCategoryOptions = mainCategories?.map(cat => ({
        value: cat._id,
        label: cat.name
    }));

    const subCategoryOptions = filteredSubCategories?.map(cat => ({
        value: cat._id,
        label: cat.name
    }));

    const getSubCategories = async (mainCategoryId = null) => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axios.get("masters/rm-sub-category/get", { headers });

            if (response?.data?.status === true) {
                const allSubCategories = response.data.data.categories;
                setSubCategories(allSubCategories);

                if (mainCategoryId) {
                    const filtered = allSubCategories.filter(sub => sub.mainCategory === mainCategoryId);
                    setFilteredSubCategories(filtered);
                }
            }
        } catch (error) {
            handleApiError(error, "Failed to fetch sub categories");
        }
    };

    const getMainCategories = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axios.get("masters/rm-main-category/get", { headers });

            if (response?.data?.status === true) {
                setMainCategories(response.data.data.categories);
            }
        } catch (error) {
            handleApiError(error, "Failed to fetch main categories");
        }
    };

    // Helper functions
    const handleApiError = (error, defaultMessage) => {
        let errorMessage = defaultMessage;

        if (error?.response) {
            if (error.response.status === 400) {
                errorMessage = error.response.data.message || error.response.data.title;
            } else if (error.response.status === 404) {
                errorMessage = error.response.data.message || "Resource not found";
            } else if (error.response.status === 406) {
                errorMessage = error.response.data.error?.message || error.response.data.error;
            } else if (error.response.status === 412) {
                errorMessage = error.response.data.data?.message || error.response.data.error;
            } else if (error.response.status === 500) {
                errorMessage = error.response.data.error || "Server error";
            }
        }

        toast.error(errorMessage);
    };

    const handleOpenNewMaterialModal = () => {
        setShowAddModal(true);
    };

    const handleSelectChange = (selectedOption, field) => {
        setFormData(prev => ({ ...prev, [field]: selectedOption?.value || "" }));

        if (field === 'mainCategory') {
            getSubCategories(selectedOption?.value);
            setFormData(prev => ({ ...prev, subCategory: "" }));
        }
    };

    const resetForm = () => {
        setFormData({
            mainCategory: "",
            subCategory: "",
            name: "",
            reOrderLevel: "",
            description: "",
            unit: "",
            hsn: "",
            taxPercent: "",
            purchaseUnit: ""
        });
    };

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const addMaterial = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const headers = { Authorization: `Bearer ${accessToken}` };
            const data = { ...formData };

            if (!data.reOrderLevel) delete data.reOrderLevel;
            if (!data.purchaseUnit) delete data.purchaseUnit;

            const response = await axios.post("raw-material", data, { headers });

            if (response?.data?.status === true) {
                toast.success(response.data.data.message);
                getRawMaterials();
                resetForm();
                setShowAddModal(false);
            }
        } catch (error) {
            handleApiError(error, "Failed to add material");
        } finally {
            setIsLoading(false);
        }
    };

    const [
        editProcurementItemValidationErrors,
        setEditProcurementItemValidationErrors,
    ] = useState({
        material: "",
        quantity: "",
        rate: "",
    });

    const rawMaterialOptions = rawMaterialList.map((rm) => ({
        value: rm._id,
        label: rm.name,
    }));

    const [filterLoading, setFilterLoading] = useState(false);

    const getOutlets = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            }
            const response = await axios.get("outlet", { headers });
            setOutlets(response?.data?.data?.outlets || []);
        } catch (error) {
            console.log("Error in Fetching Outlets :", error);
        }
    }

    const getProcurements = async (
        page,
        limit,
        sDate,
        eDate,
        vendor,
        status,
        search,
        sort,
    ) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            let url = `procurement?page=${page}&limit=${limit}&fromDate=${sDate?.toISOString().split("T")[0]}&toDate=${eDate?.toISOString().split("T")[0]}`;

            if (vendor) {
                url += `&vendorId=${vendor}`;
            }

            if (status) {
                url += `&status=${status}`;
            }

            if (sort) {
                url += `&sort=${sort}`;
            }

            if (search) {
                url += `&search=${search}`;
            }

            console.log("Procurements URL :", url);

            const response = await axios.get(url, { headers });

            if (response?.data?.status === true) {
                console.log("procurements response :", response?.data?.data);

                // Dynamically assign serial numbers
                const startIndex = (page - 1) * limit;
                const procList = response?.data?.data?.procurements.map(
                    (item, index) => ({
                        ...item,
                        serialNumber: startIndex + index + 1,
                    }),
                );

                setProcurementsList(procList);
                setFilteredData(procList);
                setTotalRecords(response?.data?.data?.pagination?.totalRecords);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                setProcurementsList([]);
                setFilteredData([]);
            }
        } finally {
            setBtnLoading(false);
        }
    };

    const handleOpenViewModal = (data) => {
        getSingleProcurementDetails(data?._id);
        console.log("Procurements data :", data);

        setOpenViewModal(true);
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const getSingleProcurementDetails = async (procurementId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get(`procurement?_id=${procurementId}`, {
                headers,
            });

            if (response?.data?.status === true) {
                setSingleProcurementDetails(response?.data?.data?.procurements);
                setSingleProcurementItemsDetails(
                    response?.data?.data?.procurementItems,
                );
                setSingleProcurementCharges(
                    response?.data?.data?.procurements?.charges || [],
                );

                console.log("response", response);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const handleEditModal = async (data) => {
        setEditedData({
            _id: data._id,
            vendor: data.vendor._id,
            actualRate: data?.actualRate,
            idNumber: data.idNumber,
            scannedInvoice: data.scannedInvoice,
            charges: data.charges || [], // Changed from additionalCharges
            invoiceDate: data.invoiceDate || null, // Add this line
        });
        setOpenEditModal(true);
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setInvoiceFile(selectedFile);
        setEditValidationErrors((prevErrors) => ({
            ...prevErrors,
            scannedInvoice: "",
        }));
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        let sanitizedValue = value;

        setEditedData((prevState) => ({ ...prevState, [name]: sanitizedValue }));
        setEditValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    };

    const handleIdNumberChange = (e) => {
        const { name, value } = e.target;

        setEditedData((prevState) => ({
            ...prevState,
            [name]: value,
        }));

        setEditValidationErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };

    // Charge handlers for edit modal
    const handleAddChargeInEdit = () => {
        setEditedData(prev => ({
            ...prev,
            charges: [...(prev.charges || []), {
                additionalCharge: "",
                taxPercent: "",
                amount: "",
                totalAmount: 0
            }]
        }));
    };

    const handleRemoveChargeInEdit = (index) => {
        setEditedData(prev => ({
            ...prev,
            charges: prev.charges.filter((_, i) => i !== index)
        }));
    };

    const handleChargeChangeInEdit = (index, field, value) => {
        setEditedData(prev => {
            const updatedCharges = [...(prev.charges || [])];
            updatedCharges[index] = {
                ...updatedCharges[index],
                [field]: value
            };

            // Recalculate total amount
            if (field === 'amount' || field === 'taxPercent') {
                const amount = field === 'amount' ? value : updatedCharges[index].amount;
                const taxPercent = field === 'taxPercent' ? value : updatedCharges[index].taxPercent;
                const taxable = Number(amount) || 0;
                const taxAmount = Number(((taxable * (taxPercent || 0)) / 100).toFixed(2));
                const totalAmount = Number((taxable + taxAmount).toFixed(2));
                updatedCharges[index].totalAmount = totalAmount;
            }

            return { ...prev, charges: updatedCharges };
        });
    };

    const calculateChargeTotal = (amount, taxPercent) => {
        const taxable = Number(amount) || 0;
        const taxAmount = Number(((taxable * (taxPercent || 0)) / 100).toFixed(2));
        const totalAmount = Number((taxable + taxAmount).toFixed(2));
        return { taxAmount, totalAmount };
    };

    const handleEditSubmit = async (e) => {
        console.log("Hello");

        e.preventDefault();

        if (!editedData.vendor) {
            setEditValidationErrors((prevErrors) => ({
                ...prevErrors,
                vendor: "Vendor is required.",
            }));
            return;
        }

        if (!editedData.idNumber) {
            setEditValidationErrors((prevErrors) => ({
                ...prevErrors,
                idNumber: "ID Number is required.",
            }));
            return;
        }

        if (Object.values(editValidationErrors).some((error) => error !== "")) {
            return;
        }

        setIsEditBtnLoading(true);

        try {
            const formData = new FormData();
            formData.append(`procurement[_id]`, editedData._id);
            formData.append(`procurementItem[actualRate]`, editedData.actualRate);
            formData.append(`procurement[vendor]`, editedData.vendor);
            formData.append(`procurement[idNumber]`, editedData.idNumber);

            // Format invoice date to DD-MM-YYYY
            if (editedData.invoiceDate) {
                const date = new Date(editedData.invoiceDate);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                const formattedDate = `${day}-${month}-${year}`;
                formData.append(`procurement[invoiceDate]`, formattedDate);
            }

            // Add charges
            const validCharges = (editedData.charges || []).filter(charge =>
                charge.additionalCharge && charge.amount
            );

            validCharges.forEach((charge, index) => {
                formData.append(`procurement[charges][${index}][additionalCharge]`, charge.additionalCharge);
                formData.append(`procurement[charges][${index}][taxPercent]`, charge.taxPercent || 0);
                formData.append(`procurement[charges][${index}][amount]`, charge.amount);
                formData.append(`procurement[charges][${index}][totalAmount]`, charge.totalAmount);
            });



            formData.append(`procurement.scannedInvoice`, invoiceFile);

            const headers = {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`,
            };
            const data = {
                procurement: editedData,
            };

            const response = await axios.put("procurement", data, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
                getProcurements(
                    currentPage,
                    recordsPerPage,
                    adjustedStartDate,
                    adjustedEndDate,
                    selectedVendor,
                    selectedStatus,
                    searchText,
                    selectedSortBy,
                );
                getSingleProcurementDetails(editedData._id);
                setOpenEditModal(false);
                setOpenViewModal(true);
                setInvoiceFile(null);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsEditBtnLoading(false);
        }
    };

    const handleCloseMainAddModal = () => {
        // Close modal and refresh data
        setShowAddPurchaseModal(false);
        setInputData({
            vendor: "",
            idNumber: "",
            procurementItems: Array.from({ length: 1 }, () => ({
                material: "",
                quantity: "",
                rate: "",
            })),
            charges: [],
        });
    };

    const handleOpenAddProcurementItemModal = (data) => {
        setOpenAddProcurementItemModal(true);
        setProcurementId(data._id);
    };

    const handleAddProcurementItemChanges = (fieldNameOrEvent, value) => {
        let fieldName;
        let fieldValue;

        if (fieldNameOrEvent?.target) {
            fieldName = fieldNameOrEvent.target.name;
            fieldValue = fieldNameOrEvent.target.value;
        } else {
            fieldName = fieldNameOrEvent;
            fieldValue = value;
        }

        if (fieldName === "material") {
            getSingleRawMaterialDetail(fieldValue);
        }

        setAddProcurementItemDetails((prevState) => {
            const updatedState = { ...prevState, [fieldName]: fieldValue };

            console.log("updatedState", updatedState);

            const { taxAmount, taxable, grandTotal } = calculateTaxAmount(
                updatedState.rate,
                updatedState.quantity,
                updatedState.taxPercent,
            );
            return {
                ...updatedState,
                taxAmount,
                taxable,
                grandTotal,
            };
        });
    };

    const addProcurementItem = async (e) => {
        e.preventDefault();
        setIsAddItemBtnLoading(true);
        try {
            const formData = new FormData();
            formData.append(`procurement[_id]`, procurementId);
            formData.append(`procurementItem[actualRate]`, addProcurementItemDetails.actualRate);
            formData.append(
                `procurementItem[material]`,
                addProcurementItemDetails.material,
            );
            formData.append(
                `procurementItem[quantity]`,
                addProcurementItemDetails.quantity,
            );
            formData.append(`procurementItem[rate]`, addProcurementItemDetails.rate);

            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const response = await axios.put("procurement", formData, { headers });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                setAddProcurementItemDetails({
                    material: "",
                    quantity: "",
                    rate: "",
                });
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
                getProcurements(
                    currentPage,
                    recordsPerPage,
                    adjustedStartDate,
                    adjustedEndDate,
                    selectedVendor,
                    selectedStatus,
                    searchText,
                    selectedSortBy,
                );
                getSingleProcurementDetails(procurementId);
                setOpenAddProcurementItemModal(false);
                setOpenViewModal(true);
                setProcurementId("");
            }
        } catch (error) {
            console.log(error.response);

            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage =
                        error?.response?.data?.data?.message ||
                        error?.response?.data?.data?.title;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsAddItemBtnLoading(false);
        }
    };

    const handleDeleteModal = async (data) => {
        setOpenDeleteModal(true);
        setProcurementId(data?._id);
    };

    const handleDeleteProcurement = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                procurementId,
            };

            const response = await axios.delete(`procurement`, { data, headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                setProcurementId("");
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
                getProcurements(
                    currentPage,
                    recordsPerPage,
                    adjustedStartDate,
                    adjustedEndDate,
                    selectedVendor,
                    selectedStatus,
                    searchText,
                    selectedSortBy,
                );
                setOpenDeleteModal(false);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    };

    const handleOpenUpdateStatusModal = (data) => {
        setOpenUpdateStatusModal(true);
        setProcurementId(data._id);
    };

    const handleProcurementUpdateStatus = async (e) => {
        e.preventDefault();
        setIsStatusBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                procurementId,
            };

            if (selectedStorageLocation) {
                data.storageLocation = selectedStorageLocation;
            }

            if (selectedOutlet) {
                data.outlet = selectedOutlet;
            }

            const response = await axios.put("procurement/status", data, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                resetModalFields();

                setProcurementId("");
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
                getProcurements(
                    currentPage,
                    recordsPerPage,
                    adjustedStartDate,
                    adjustedEndDate,
                    selectedVendor,
                    selectedStatus,
                    searchText,
                    selectedSortBy,
                );
                setOpenUpdateStatusModal(false);
            }
        } catch (error) {
            console.log("Error in Updating Status :", error);
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error || error?.response?.data?.data?.title;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message || error?.response?.data?.data?.title;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setIsStatusBtnLoading(false);
        }
    };

    const handleOpenProcurementItemEditModal = (data) => {
        console.log("data", data);

        setOpenProcurementItemEditModal(true);
        setProcurementId(singleProcurementDetails._id);

        // Calculate actualRate based on unit
        let actualRate = data.rate || 0;
        const unit = data?.material?.unit || "";
        const quantity = data.quantity || 0;

        if (unit === "GRAMS" || unit === "ML") {
            actualRate = data.rate * data.quantity;
        }

        setEditProcurementItemDetails({
            _id: data._id,
            material: data.material?._id || "",
            quantity: data.quantity || 0,
            rate: data.rate || 0,
            taxAmount: data?.taxAmount || 0,
            taxable: data?.taxable || 0,
            grandTotal: data?.grandTotal || 0,
            taxPercent: data?.material?.taxPercent || 0,
            unit: unit,
            actualRate: Number(actualRate.toFixed(2)),
        });
    };

    const handleEditProcurementItemChange = (name, value) => {
        setEditProcurementItemDetails((prevState) => {
            const updatedState = { ...prevState, [name]: value };

            // If material is changed, fetch taxPercent and unit
            if (name === "material" && value) {
                getSingleRawMaterialDetail(value);
            }

            // Recalculate amounts if rate, quantity, or taxPercent changes
            const { taxAmount, taxable, grandTotal } = calculateTaxAmount(
                updatedState.rate,
                updatedState.quantity,
                updatedState.taxPercent,
            );

            return {
                ...updatedState,
                taxAmount,
                taxable,
                grandTotal,
            };
        });

        // Reset validation error for the field
        setEditProcurementItemValidationErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };

    const handleEditProcurementItemSubmit = async (e) => {
        e.preventDefault();
        if (!editProcurementItemDetails.material) {
            setEditProcurementItemValidationErrors((prevErrors) => ({
                ...prevErrors,
                material: "Material is required.",
            }));
            return;
        }
        if (!editProcurementItemDetails.quantity) {
            setEditProcurementItemValidationErrors((prevErrors) => ({
                ...prevErrors,
                quantity: "Quantity is required.",
            }));
            return;
        }
        if (!editProcurementItemDetails.rate) {
            setEditProcurementItemValidationErrors((prevErrors) => ({
                ...prevErrors,
                rate: "Rate is required.",
            }));
            return;
        }
        setIsEditItemBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const formData = new FormData();
            formData.append(`procurement[_id]`, procurementId);
            formData.append(`procurementItem[_id]`, editProcurementItemDetails._id);
            formData.append(`procurementItem[actualRate]`, editedData.actualRate);

            formData.append(
                `procurementItem[material]`,
                editProcurementItemDetails.material,
            );
            formData.append(
                `procurementItem[quantity]`,
                editProcurementItemDetails.quantity,
            );
            formData.append(`procurementItem[rate]`, editProcurementItemDetails.rate);

            const response = await axios.put("procurement", formData, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
                getProcurements(
                    currentPage,
                    recordsPerPage,
                    adjustedStartDate,
                    adjustedEndDate,
                    selectedVendor,
                    selectedStatus,
                    searchText,
                    selectedSortBy,
                );
                setOpenProcurementItemEditModal(false);
                setOpenViewModal(true);
                getSingleProcurementDetails(singleProcurementDetails._id);
                setProcurementId("");
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsEditItemBtnLoading(false);
        }
    };

    const handleOpenProcurementItemDeleteModal = (data) => {
        setOpenViewModal(false);
        setOpenProcurementDeleteModal(true);
        setProcurementId(data.procurement);
        setProcurmentItemIds((prevIds) => [...prevIds, data._id]);
    };

    const handleDeleteProcurementItems = async (e) => {
        e.preventDefault();
        setIsItemDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const data = {
                procurementItemIds: procurementItemIds,
            };

            const response = await axios.delete("procurement", { data, headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
                getProcurements(
                    currentPage,
                    recordsPerPage,
                    adjustedStartDate,
                    adjustedEndDate,
                    selectedVendor,
                    selectedStatus,
                    searchText,
                    selectedSortBy,
                );
                setProcurmentItemIds([]);
                setOpenProcurementDeleteModal(false);
                getSingleProcurementDetails(procurementId);
                setOpenViewModal(true);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsItemDeleteBtnLoading(false);
        }
    };

    const handleOpenProcurementItemUpdateStatus = (data) => {
        setOpenUpdateStatusItemModal(true);
        setItemId((prevIds) => [...prevIds, data._id]);
    };

    const handleProcurementItemUpdateStatus = async (e) => {
        e.preventDefault();
        setIsItemStatusBtnLoading(true);

        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                procurementItemIds: itemId,
            };

            if (selectedStorageLocation) {
                data.storageLocation = selectedStorageLocation;
            }

            if (selectedOutlet) {
                data.outlet = selectedOutlet;
            }

            const response = await axios.put("procurement/status", data, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });

                setProcurementId("");
                setItemId([]);
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
                getProcurements(
                    currentPage,
                    recordsPerPage,
                    adjustedStartDate,
                    adjustedEndDate,
                    selectedVendor,
                    selectedStatus,
                    searchText,
                    selectedSortBy,
                );
                resetModalFields();
                setOpenUpdateStatusItemModal(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message || error?.response?.data?.data?.title;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setIsItemStatusBtnLoading(false);
        }
    };

    const handleOpenEditStatusWithRemarksModal = (data) => {
        setProcurementId(data._id);
        setOpenEditStatusWithRemarksModal(true);
    };

    const handleEditStatusWithRemarksSubmit = async (e) => {
        e.preventDefault();

        if (!remark) {
            setValidateRemark("Remark is required");
            return;
        }

        setIsEditWithRemarkBtnLoading(true);

        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                storageLocation: selectedStorageLocation,
                procurementId: procurementId,
                remark: remark,
            };

            const response = await axios.put("procurement/status", data, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
                getProcurements(
                    currentPage,
                    recordsPerPage,
                    adjustedStartDate,
                    adjustedEndDate,
                    selectedVendor,
                    selectedStatus,
                    searchText,
                    selectedSortBy,
                );
                getSingleProcurementDetails(procurementId);
                setOpenEditStatusWithRemarksModal(false);
                setOpenViewModal(true);
                setProcurementId("");
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsEditWithRemarkBtnLoading(false);
        }
    };

    const getVendors = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("vendor", { headers });
            if (response?.data?.status === true) {
                setVendors(response?.data?.data?.vendors);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getRawMaterials = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("raw-material", { headers });

            if (response?.data?.status === true) {
                setRawMaterialList(response?.data?.data?.rawMaterials);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getSingleRawMaterialDetail = async (materialId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get(`raw-material?_id=${materialId}`, {
                headers,
            });

            if (response?.data?.status === true) {
                const taxPercent = response?.data?.data?.rawMaterials?.taxPercent;
                const unit = response?.data?.data?.rawMaterials?.unit;
                setAddProcurementItemDetails((prevState) => ({
                    ...prevState,
                    taxPercent: taxPercent,
                    unit: unit,
                }));
                setEditProcurementItemDetails((prevState) => ({
                    ...prevState,
                    taxPercent: taxPercent,
                    unit: unit,
                }));
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const calculateTaxAmount = (
        rate,
        quantity,
        taxPercent,
        unit,
        actualRate
    ) => {
        let taxable = 0;

        if (unit === "GRAMS" || unit === "ML") {
            taxable = actualRate * (quantity / 1000);
        } else {
            taxable = rate * quantity;
        }

        taxable = Number(taxable.toFixed(2));

        const taxAmount = Number(((taxable * taxPercent) / 100).toFixed(2));
        const grandTotal = Number((taxable + taxAmount).toFixed(2));

        return { taxable, taxAmount, grandTotal };
    };


    const handleCloseAddProcurementItemModal = () => {
        setAddProcurementItemDetails({
            material: "",
            quantity: "",
            rate: "",
            taxPercent: "",
            taxAmount: "",
            taxable: "",
            grandTotal: "",
            unit: "",
        });
        setOpenAddProcurementItemModal(false);
    };

    const getPaginatedData = () => {
        const startIndex = (pagination.page - 1) * pagination.recordsPerPage;
        const endIndex = startIndex + pagination.recordsPerPage;
        return filteredData?.slice(startIndex, endIndex);
    };

    // Calculate totals including charges
    const totals = singleProcurementItemsDetails?.reduce(
        (acc, item) => {
            const taxable = item?.taxable;
            const taxAmount = item?.taxAmount;
            const grandTotal = item?.grandTotal;

            acc.totalTaxable += taxable;
            acc.totalTaxAmount += taxAmount;
            acc.totalGrandTotal += grandTotal;

            return acc;
        },
        {
            totalTaxable: 0,
            totalTaxAmount: 0,
            totalGrandTotal: 0,
        },
    );

    // Calculate charges total
    // const chargesTotal = singleProcurementCharges?.reduce(
    //     (acc, charge) => {
    //         acc.totalChargeAmount += charge.amount || 0;
    //         acc.totalChargeTax += charge.taxAmount || 0;
    //         acc.totalChargeTotal += charge.totalAmount || 0;
    //         return acc;
    //     },
    //     {
    //         totalChargeAmount: 0,
    //         totalChargeTax: 0,
    //         totalChargeTotal: 0,
    //     }
    // ) || { totalChargeAmount: 0, totalChargeTax: 0, totalChargeTotal: 0 };
    const chargesTotal = singleProcurementCharges?.reduce(
        (acc, charge) => {
            const amount = charge.amount || 0;
            const totalAmount = charge.totalAmount || 0;

            // Calculate tax
            const taxAmount = totalAmount - amount;

            acc.totalChargeAmount += amount;
            acc.totalChargeTax += taxAmount;
            acc.totalChargeTotal += totalAmount;

            return acc;
        },
        {
            totalChargeAmount: 0,
            totalChargeTax: 0,
            totalChargeTotal: 0,
        }
    ) || { totalChargeAmount: 0, totalChargeTax: 0, totalChargeTotal: 0 };

    const handleEndDateChange = (date) => {
        if (date && startDate && date < startDate) {
            setError("End date cannot be earlier than start date");
        } else {
            setError("");
            setEndDate(date);
        }
    };

    const handleChange = (vendor) => {
        setSelectedVendor(vendor);
    };

    const handleSubmitFilters = async () => {
        setBtnLoading(true);
        const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
        const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));

        await getProcurements(
            currentPage,
            recordsPerPage,
            adjustedStartDate,
            adjustedEndDate,
            selectedVendor,
            selectedStatus,
            searchText,
            selectedSortBy,
        );
        setBtnLoading(false);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        const adjustedStartDate = startDate
            ? new Date(new Date(startDate).setHours(23, 59, 59, 999))
            : null;
        const adjustedEndDate = endDate
            ? new Date(new Date(endDate).setHours(23, 59, 59, 999))
            : null;
        getProcurements(
            page,
            recordsPerPage,
            adjustedStartDate,
            adjustedEndDate,
            selectedVendor,
            selectedStatus,
            searchText,
            selectedSortBy,
        );
    };

    const handlerecordsPerPageChange = (newPerPage) => {
        setRecordsPerPage(newPerPage);
        setCurrentPage(1);

        const adjustedStartDate = startDate
            ? new Date(new Date(startDate).setHours(23, 59, 59, 999))
            : null;
        const adjustedEndDate = endDate
            ? new Date(new Date(endDate).setHours(23, 59, 59, 999))
            : null;
        getProcurements(
            1,
            newPerPage,
            adjustedStartDate,
            adjustedEndDate,
            selectedVendor,
            selectedStatus,
            searchText,
            selectedSortBy,
        );
    };

    const handleFilter = async () => {
        setFilterLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const params = {};

            if (filterState) params.state = filterState;
            if (filterCity) params.city = filterCity;

            const response = await axios.get("storage-location", {
                headers,
                params,
            });
            console.log("Response :", response);

            setStorageLocationList(response?.data?.data?.storageLocations);
            if (filterState !== "" || filterCity !== "") {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                const errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setFilterLoading(false);
        }
    };

    const resetModalFields = () => {
        setFilterCity("");
        setFilterState("");
        setSelectedStorageLocation("");
        setSelectedOutlet("");
        setFilterLoading(false);
    };

    useEffect(() => {
        handleFilter();
    }, []);

    useEffect(() => {
        const now = new Date();
        const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const currentDate = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate(),
        );

        const start = new Date(firstOfMonth.setHours(23, 59, 59, 999));
        const end = new Date(currentDate.setHours(23, 59, 59, 999));
        setStartDate(start);
        setEndDate(end);

        getProcurements(currentPage, recordsPerPage, start, end);
    }, []);

    useEffect(() => {
        getVendors();
        getRawMaterials();
        getOutlets();
    }, []);

    useEffect(() => {
        const result = procurementsList.filter((item) => {
            return (
                (item.vendor.name &&
                    item.vendor.name.toLowerCase().includes(searchText.toLowerCase())) ||
                (item.vendor.email &&
                    item.vendor.email.toLowerCase().includes(searchText.toLowerCase())) ||
                (item.vendor.phone &&
                    item.vendor.phone.toLowerCase().includes(searchText.toLowerCase())) ||
                (item.scannedInvoice &&
                    item.scannedInvoice
                        .toLowerCase()
                        .includes(searchText.toLowerCase())) ||
                (item.status &&
                    item.status.toLowerCase().includes(searchText.toLowerCase())) ||
                (item.idNumber && item.idNumber.toString().includes(searchText)) ||
                (item.financialYear &&
                    item.financialYear.toString().includes(searchText)) ||
                (item.totalTaxAmount &&
                    item.totalTaxAmount.toString().includes(searchText)) ||
                (item.taxable && item.taxable.toString().includes(searchText)) ||
                (item.grandTotal && item.grandTotal.toString().includes(searchText))
            );
        });
        setFilteredData(result);
    }, [procurementsList]);

    useEffect(() => {
        if (!searchText && touched) {
            const adjustedStartDate = new Date(startDate?.setHours(23, 59, 59, 999));
            const adjustedEndDate = new Date(endDate?.setHours(23, 59, 59, 999));
            getProcurements(
                currentPage,
                recordsPerPage,
                adjustedStartDate,
                adjustedEndDate,
            );
        }
    }, [searchText]);

    // Add all the handler functions from AddPurchase component here
    const handleAddItem = () => {
        const procurementItemErrors = inputData.procurementItems.map(
            validateProcurementItem,
        );
        if (
            procurementItemErrors.some((errors) => Object.keys(errors).length > 0)
        ) {
            setValidationErrors((prevErrors) => ({
                ...prevErrors,
                procurementItems: procurementItemErrors,
            }));
            return;
        }

        setInputData((prevData) => ({
            ...prevData,
            procurementItems: [
                ...prevData.procurementItems,
                {
                    material: "",
                    quantity: "",
                    rate: "",
                    taxPercent: "",
                },
            ],
        }));
    };

    const handleRemoveItem = (index) => {
        setInputData((prevData) => {
            const updatedItems = [...prevData.procurementItems];
            updatedItems.splice(index, 1);
            return {
                ...prevData,
                procurementItems: updatedItems,
            };
        });
    };

    // Charge handlers for Add Purchase Modal
    const handleAddCharge = () => {
        setInputData(prev => ({
            ...prev,
            charges: [...prev.charges, {
                additionalCharge: "",
                taxPercent: "",
                amount: "",
                totalAmount: 0
            }]
        }));

        setValidationErrors(prev => ({
            ...prev,
            charges: [...(prev.charges || []), {}]
        }));
    };

    const handleRemoveCharge = (index) => {
        setInputData(prev => ({
            ...prev,
            charges: prev.charges.filter((_, i) => i !== index)
        }));

        setValidationErrors(prev => ({
            ...prev,
            charges: prev.charges.filter((_, i) => i !== index)
        }));
    };

    const handleChargeChange = (index, field, value) => {
        setInputData(prev => {
            const updatedCharges = [...prev.charges];
            updatedCharges[index] = {
                ...updatedCharges[index],
                [field]: value
            };

            // Recalculate total amount
            if (field === 'amount' || field === 'taxPercent') {
                const amount = field === 'amount' ? value : updatedCharges[index].amount;
                const taxPercent = field === 'taxPercent' ? value : updatedCharges[index].taxPercent;
                const taxable = Number(amount) || 0;
                const taxAmount = Number(((taxable * (taxPercent || 0)) / 100).toFixed(2));
                const totalAmount = Number((taxable + taxAmount).toFixed(2));
                updatedCharges[index].totalAmount = totalAmount;
            }

            return { ...prev, charges: updatedCharges };
        });

        setValidationErrors(prev => {
            const updatedChargeErrors = [...(prev.charges || [])];
            if (!updatedChargeErrors[index]) {
                updatedChargeErrors[index] = {};
            }
            updatedChargeErrors[index][field] = "";
            return { ...prev, charges: updatedChargeErrors };
        });
    };

    const validateCharge = (charge) => {
        const errors = {};

        if (!charge.additionalCharge || !charge.additionalCharge.trim()) {
            errors.additionalCharge = "Charge name is required";
        }

        if (!charge.amount || Number(charge.amount) <= 0) {
            errors.amount = "Amount must be greater than 0";
        }

        if (charge.taxPercent === "" || charge.taxPercent === null || charge.taxPercent === undefined) {
            errors.taxPercent = "Tax % is required";
        }

        return errors;
    };

    const handlePurchaseChange = (e, index) => {
        const { name, value } = e.target;

        if (name === "idNumber") {
            setValidationErrors((prev) => ({ ...prev, idNumber: "" }));
            setInputData((prev) => ({ ...prev, idNumber: value }));
            return;
        }

        setValidationErrors((prev) => ({ ...prev, [name]: "" }));
        setValidationErrors((prev) => ({ ...prev, procurementItems: [] }));

        if (["material", "quantity", "rate"].includes(name)) {

            if (name === "material") {
                getSingleRawMaterialDetail(value, index);
            }

            setInputData((prev) => {
                const items = [...prev.procurementItems];
                const item = { ...items[index] };

                if (name === "material") {
                    items[index] = {
                        ...item,
                        material: value,

                        quantity: "",
                        rate: "",
                        actualRate: "",

                        taxable: 0,
                        taxAmount: 0,
                        grandTotal: 0,
                    };

                    return { ...prev, procurementItems: items };
                }

                item[name] = parseFloat(value) || 0;

                const rate = Number(item.rate) || 0;
                const quantity = Number(item.quantity) || 0;
                const taxPercent = Number(item.taxPercent) || 0;

                const { taxable, taxAmount, grandTotal } = calculateTaxAmount(
                    rate,
                    quantity,
                    taxPercent,
                    item.unit,
                    item.actualRate
                );

                items[index] = {
                    ...item,
                    taxable: Number(taxable.toFixed(2)),
                    taxAmount: Number(taxAmount.toFixed(2)),
                    grandTotal: Number(grandTotal.toFixed(2)),
                };

                return { ...prev, procurementItems: items };
            });

            return;
        }

        setInputData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handlePurchaseFileChange = (e) => {
        setValidationErrors((prevErrors) => ({ ...prevErrors, invoiceFile: "" }));
        const selectedFile = e.target.files[0];
        setInvoiceFile(selectedFile);
    };

    const validateProcurementItem = (item) => {
        const errors = {};

        if (!item.material || !item.material.trim()) {
            errors.material = "Material is required.";
        }

        if (item.quantity === null || item.quantity === undefined || Number(item.quantity) <= 0) {
            errors.quantity = "Quantity must be greater than 0.";
        }

        if (item.rate === null || item.rate === undefined || Number(item.rate) <= 0) {
            errors.rate = "Rate must be greater than 0.";
        }

        return errors;
    };

    const handlePurchaseSubmit = async (e) => {
        e.preventDefault();
        if (!inputData.vendor) {
            setValidationErrors((prevErrors) => ({
                ...prevErrors,
                vendor: "Vendor is required.",
            }));
            return;
        }

        if (!inputData.idNumber) {
            setValidationErrors((prevErrors) => ({
                ...prevErrors,
                idNumber: "ID Number is required.",
            }));
            return;
        }

        const procurementItemErrors = inputData.procurementItems.map(
            validateProcurementItem,
        );
        if (
            procurementItemErrors.some((errors) => Object.keys(errors).length > 0)
        ) {
            setValidationErrors((prevErrors) => ({
                ...prevErrors,
                procurementItems: procurementItemErrors,
            }));
            return;
        }

        // Validate charges
        const validCharges = inputData.charges.filter(charge =>
            charge.additionalCharge && charge.amount
        );

        const chargeErrors = validCharges.map(validateCharge);
        const hasChargeErrors = chargeErrors.some(errors => Object.keys(errors).length > 0);

        if (hasChargeErrors) {
            setValidationErrors(prev => ({ ...prev, charges: chargeErrors }));
            toast.error("Please fix errors in additional charges");
            return;
        }

        setIsPurchaseLoading(true);

        try {
            const formData = new FormData();
            formData.append("procurement[vendor]", inputData.vendor);
            formData.append("procurement[idNumber]", inputData.idNumber);
            formData.append("procurement.scannedInvoice", invoiceFile);

            inputData.procurementItems.forEach((item, index) => {
                formData.append(`procurementItems[${index}][material]`, item.material);
                formData.append(`procurementItems[${index}][quantity]`, item.quantity);
                formData.append(`procurementItems[${index}][rate]`, item.rate);
            });

            // Add charges
            validCharges.forEach((charge, index) => {
                formData.append(`procurement[charges][${index}][additionalCharge]`, charge.additionalCharge);
                formData.append(`procurement[charges][${index}][taxPercent]`, charge.taxPercent || 0);
                formData.append(`procurement[charges][${index}][amount]`, charge.amount);
                formData.append(`procurement[charges][${index}][totalAmount]`, charge.totalAmount);
            });

            const headers = {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`,
            };

            const response = await axios.post("procurement", formData, { headers });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                e.target.reset();
                setInputData({
                    vendor: "",
                    idNumber: "",
                    procurementItems: Array.from({ length: 1 }, () => ({
                        material: "",
                        quantity: "",
                        rate: "",
                    })),
                    charges: [],
                });
                setShowAddPurchaseModal(false);
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
                getProcurements(
                    currentPage,
                    recordsPerPage,
                    adjustedStartDate,
                    adjustedEndDate,
                );
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsPurchaseLoading(false);
        }
    };

    const purchaseBtnDisable = () => {
        let isDisable = false;

        if (
            !inputData.vendor ||
            !inputData.idNumber
        ) {
            isDisable = true;
        }

        for (let i = 0; i < inputData.procurementItems.length; i++) {
            const item = inputData.procurementItems[i];

            if (!item.material || !item.quantity || !item.rate) {
                isDisable = true;
                break;
            }
        }

        return isDisable;
    };

    const handleRateChange = (e, index) => {
        const actualRate = parseFloat(e.target.value) || 0;

        setInputData((prev) => {
            const items = [...prev.procurementItems];
            const item = { ...items[index] };

            const quantity = parseFloat(item.quantity) || 0;
            const unit = item.unit;

            let rate = actualRate;

            if ((unit === "GRAMS" || unit === "ML") && actualRate > 0 && quantity > 0) {
                rate = actualRate / quantity;
            }

            rate = Number(rate.toFixed(5));

            const { taxable, taxAmount, grandTotal } = calculateTaxAmount(
                rate,
                quantity,
                item.taxPercent,
                unit,
                actualRate
            );

            items[index] = {
                ...item,
                actualRate,
                rate,
                taxable,
                taxAmount,
                grandTotal,
            };

            return { ...prev, procurementItems: items };
        });
    };

    const renderAddPurchaseModal = () => (
        <Modal
            size="xl"
            show={showAddPurchaseModal}
            onHide={handleCloseMainAddModal}
        >
            <Modal.Header closeButton>
                <Modal.Title>ADD NEW PURCHASE</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handlePurchaseSubmit}>
                    <Row className="g-3 mb-4">
                        <Col md={6} lg={4}>
                            <Form.Group controlId="vendorSelect">
                                <Form.Label className="fw-semibold">
                                    Vendor <span className="text-danger">*</span>
                                </Form.Label>
                                <Select
                                    options={vendors.map((vendor) => ({
                                        value: vendor._id,
                                        label: vendor.name,
                                    }))}
                                    value={
                                        inputData.vendor
                                            ? {
                                                value: inputData.vendor,
                                                label: vendors.find(
                                                    (vendor) => vendor._id === inputData.vendor,
                                                )?.name,
                                            }
                                            : null
                                    }
                                    onChange={(selectedOption) => {
                                        if (selectedOption) {
                                            handlePurchaseChange({
                                                target: { name: "vendor", value: selectedOption.value },
                                            });
                                        } else {
                                            handlePurchaseChange({
                                                target: { name: "vendor", value: "" },
                                            });
                                        }
                                    }}
                                    classNamePrefix="react-select"
                                    isClearable
                                    placeholder="Select Vendor"
                                />
                                {validationErrors.vendor && (
                                    <Form.Text className="text-danger">
                                        {validationErrors.vendor}
                                    </Form.Text>
                                )}
                            </Form.Group>
                        </Col>

                        <Col md={6} lg={4}>
                            <Form.Group controlId="idNumber">
                                <Form.Label className="fw-semibold">
                                    Invoice Number <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Invoice Number"
                                    name="idNumber"
                                    value={inputData?.idNumber}
                                    onChange={handlePurchaseChange}
                                />
                                {validationErrors.idNumber && (
                                    <Form.Text className="text-danger">
                                        {validationErrors.idNumber}
                                    </Form.Text>
                                )}
                            </Form.Group>
                        </Col>

                        <Col md={6} lg={4}>
                            <Form.Group controlId="invoiceFile">
                                <Form.Label className="fw-semibold">Scanned Invoice</Form.Label>
                                <Form.Control
                                    type="file"
                                    onChange={handlePurchaseFileChange}
                                    accept=".txt, .png, .jpg, .jpeg, .pdf, .doc, .docx"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {/* Additional Charges Section */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="mb-0">Additional Charges</h6>
                        <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={handleAddCharge}
                        >
                            <i className="bi bi-plus-lg me-1"></i> Add Charge
                        </Button>
                    </div>

                    {inputData.charges.length > 0 && (
                        <Card className="mb-4">
                            <Card.Body className="p-3">
                                {inputData.charges.map((charge, index) => (
                                    <Row key={index} className="g-2 mb-2 align-items-end">
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label style={{ fontSize: '0.85rem' }}>
                                                    Charge Name <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="e.g., Freight, Handling"
                                                    value={charge.additionalCharge}
                                                    onChange={(e) => handleChargeChange(index, 'additionalCharge', e.target.value)}
                                                    size="sm"
                                                    isInvalid={validationErrors.charges?.[index]?.additionalCharge}
                                                />
                                                {validationErrors.charges?.[index]?.additionalCharge && (
                                                    <Form.Control.Feedback type="invalid" style={{ fontSize: '0.75rem' }}>
                                                        {validationErrors.charges[index].additionalCharge}
                                                    </Form.Control.Feedback>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Label style={{ fontSize: '0.85rem' }}>
                                                    Tax % <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    step="any"
                                                    placeholder="0"
                                                    value={charge.taxPercent}
                                                    onChange={(e) => handleChargeChange(index, 'taxPercent', e.target.value)}
                                                    size="sm"
                                                    isInvalid={validationErrors.charges?.[index]?.taxPercent}
                                                />
                                                {validationErrors.charges?.[index]?.taxPercent && (
                                                    <Form.Control.Feedback type="invalid" style={{ fontSize: '0.75rem' }}>
                                                        {validationErrors.charges[index].taxPercent}
                                                    </Form.Control.Feedback>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Label style={{ fontSize: '0.85rem' }}>
                                                    Amount <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    step="any"
                                                    placeholder="0.00"
                                                    value={charge.amount}
                                                    onChange={(e) => handleChargeChange(index, 'amount', e.target.value)}
                                                    size="sm"
                                                    isInvalid={validationErrors.charges?.[index]?.amount}
                                                />
                                                {validationErrors.charges?.[index]?.amount && (
                                                    <Form.Control.Feedback type="invalid" style={{ fontSize: '0.75rem' }}>
                                                        {validationErrors.charges[index].amount}
                                                    </Form.Control.Feedback>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group>
                                                <Form.Label style={{ fontSize: '0.85rem' }}>
                                                    Total Amount
                                                </Form.Label>
                                                <Form.Control
                                                    disabled
                                                    type="text"
                                                    value={`₹${(charge.totalAmount || 0).toFixed(2)}`}
                                                    size="sm"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={1} className="d-flex align-items-end">
                                            <Button
                                                variant="outline-danger"
                                                size="sm"
                                                onClick={() => handleRemoveCharge(index)}
                                                title="Remove charge"
                                            >
                                                <i className="bi bi-dash-lg"></i>
                                            </Button>
                                        </Col>
                                    </Row>
                                ))}
                            </Card.Body>
                        </Card>
                    )}

                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0">Purchase Items</h5>
                    </div>
                    <hr className="mb-4" />

                    {inputData.procurementItems.map((item, index) => (
                        <Card key={index} className="mb-3 border">
                            <Card.Body className="p-3">
                                <div className="text-end">
                                    <Button
                                        variant="outline-success"
                                        size="sm"
                                        onClick={handleAddItem}
                                    >
                                        <i className="bi bi-plus-lg me-1"></i> Add Item
                                    </Button>
                                </div>
                                <Row className="g-3">
                                    <Col md={4}>
                                        <Form.Group controlId={`material-${index}`}>
                                            <Form.Label className="fw-semibold d-flex justify-content-between">
                                                <span>Raw Material<span className="text-danger">*</span></span>
                                                <Button
                                                    variant="link"
                                                    size="sm"
                                                    onClick={() => handleOpenNewMaterialModal()}
                                                    className="p-0 text-decoration-none"
                                                >
                                                    <i className="bi bi-plus-circle me-1"></i>
                                                    Add New
                                                </Button>
                                            </Form.Label>
                                            <Select
                                                options={rawMaterialList.map((rm) => ({
                                                    value: rm._id,
                                                    label: rm.name,
                                                }))}
                                                value={
                                                    item?.material
                                                        ? {
                                                            value: item.material,
                                                            label: rawMaterialList?.find(
                                                                (rm) => rm._id === item.material,
                                                            )?.name,
                                                        }
                                                        : null
                                                }
                                                onChange={async (selectedOption) => {
                                                    const materialId = selectedOption ? selectedOption.value : "";
                                                    handlePurchaseChange(
                                                        { target: { name: "material", value: materialId } },
                                                        index
                                                    );

                                                    if (materialId) {
                                                        try {
                                                            const headers = {
                                                                Authorization: `Bearer ${accessToken}`,
                                                            };
                                                            const response = await axios.get(`raw-material?_id=${materialId}`, { headers });

                                                            if (response?.data?.status === true) {
                                                                const raw = response?.data?.data?.rawMaterials;
                                                                const taxPercent = raw?.taxPercent || 0;
                                                                const unit = raw?.unit || "";

                                                                setInputData((prevData) => {
                                                                    const updatedItems = [...prevData.procurementItems];
                                                                    updatedItems[index] = {
                                                                        ...updatedItems[index],
                                                                        taxPercent,
                                                                        unit,
                                                                    };
                                                                    return { ...prevData, procurementItems: updatedItems };
                                                                });
                                                            }
                                                        } catch (error) {
                                                            console.error("Error fetching raw material details:", error);
                                                            toast.error("Failed to fetch raw material details");
                                                        }
                                                    } else {
                                                        setInputData((prevData) => {
                                                            const updatedItems = [...prevData.procurementItems];
                                                            updatedItems[index] = {
                                                                ...updatedItems[index],
                                                                taxPercent: 0,
                                                                unit: "",
                                                            };
                                                            return { ...prevData, procurementItems: updatedItems };
                                                        });
                                                    }
                                                }}
                                                classNamePrefix="react-select"
                                                isClearable
                                                placeholder="Select Material"
                                            />
                                            {validationErrors.procurementItems[index]?.material && (
                                                <Form.Text className="text-danger">
                                                    {validationErrors.procurementItems[index]?.material}
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group controlId={`quantity-${index}`}>
                                            <Form.Label className="fw-semibold">
                                                Quantity <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                step="any"
                                                type="number"
                                                placeholder="0"
                                                name="quantity"
                                                value={item.quantity}
                                                onChange={(e) => handlePurchaseChange(e, index)}
                                            />
                                            {validationErrors.procurementItems[index]?.quantity && (
                                                <Form.Text className="text-danger">
                                                    {validationErrors.procurementItems[index]?.quantity}
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>

                                    <Col md={1}>
                                        <Form.Group controlId={`unit-${index}`}>
                                            <Form.Label className="fw-semibold">Unit</Form.Label>
                                            <Form.Control
                                                disabled
                                                type="text"
                                                value={inputData.procurementItems[index]?.unit || ""}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group controlId={`rate-${index}`}>
                                            <Form.Label className="fw-semibold">
                                                Actual Rate (₹) <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                step="any"
                                                type="number"
                                                placeholder="0.00"
                                                name="actualRate"
                                                value={item.actualRate || ""}
                                                onChange={(e) => handleRateChange(e, index)}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group controlId={`rate-${index}`}>
                                            <Form.Label className="fw-semibold">
                                                Rate (₹) <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                step="any"
                                                type="number"
                                                placeholder="0.00"
                                                name="rate"
                                                value={item.rate}
                                                onChange={(e) => handlePurchaseChange(e, index)}
                                            />

                                            {validationErrors.procurementItems[index]?.rate && (
                                                <Form.Text className="text-danger">
                                                    {validationErrors.procurementItems[index]?.rate}
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>

                                    <Col md={2} className="d-flex align-items-end">
                                        <div className="d-flex">
                                            {inputData.procurementItems.length > 1 && (
                                                <Button
                                                    variant="outline-danger"
                                                    size="sm"
                                                    onClick={() => handleRemoveItem(index)}
                                                    className="ms-2"
                                                    title="Remove Item"
                                                >
                                                    <i className="bi bi-dash-lg"></i>
                                                </Button>
                                            )}
                                        </div>
                                    </Col>
                                </Row>

                                <Row className="g-3 mt-2">
                                    <Col md={3}>
                                        <Form.Group controlId={`taxPercent-${index}`}>
                                            <Form.Label className="fw-semibold">
                                                Tax Percent
                                            </Form.Label>
                                            <Form.Control
                                                disabled
                                                type="text"
                                                value={`${inputData.procurementItems[index].taxPercent || "0"}%`}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group controlId={`taxable-${index}`}>
                                            <Form.Label className="fw-semibold">
                                                Taxable Amount
                                            </Form.Label>
                                            <Form.Control
                                                disabled
                                                type="text"
                                                value={`₹${parseFloat(inputData.procurementItems[index].taxable || "0").toFixed(2)}`}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group controlId={`taxAmount-${index}`}>
                                            <Form.Label className="fw-semibold">
                                                Tax Amount
                                            </Form.Label>
                                            <Form.Control
                                                disabled
                                                type="text"
                                                value={`₹${parseFloat(inputData.procurementItems[index].taxAmount || "0").toFixed(2)}`}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group controlId={`grandTotal-${index}`}>
                                            <Form.Label className="fw-semibold">
                                                Grand Total
                                            </Form.Label>
                                            <Form.Control
                                                disabled
                                                type="text"
                                                value={`₹${parseFloat(inputData.procurementItems[index].grandTotal || "0").toFixed(2)}`}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    ))}

                    <div className="d-flex justify-content-end mt-4">
                        <Button
                            variant="primary"
                            type="submit"
                            disabled={purchaseBtnDisable() || isPurchaseLoading}
                            className="px-4"
                        >
                            {isPurchaseLoading ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    <span className="ms-2">Processing...</span>
                                </>
                            ) : (
                                "Submit Purchase"
                            )}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div
                className={`main main-app p-3 p-lg-3 ${skin === "dark" ? "bg-dark text-white" : "bg-light"}`}
            >
                <Container fluid>
                    <div
                        className="container shadow-sm"
                        style={{ backgroundColor: "white" }}
                    >
                        <Row className="pt-3 align-items-center">
                            <Col>
                                <h4 className="fw-semibold">PURCHASE LIST</h4>
                            </Col>
                            <Col className="text-end mb-2">
                                {(purchaseAccess.includes("PurchaseList:add") ||
                                    email === "contact@xpansecafe.com") && (
                                        <Button
                                            variant="success"
                                            onClick={() => {
                                                navigate("/purchase/add-purchase")
                                            }
                                            }
                                        >
                                            <i className="bi bi-plus-lg me-1"></i> Add Purchase
                                        </Button>
                                    )}
                            </Col>
                            <hr />
                        </Row>

                        {/* Filters Row - Same as before */}
                        <Row className="mb-3">
                            <Col md={3}>
                                <Form.Label className="fw-semibold text-secondary">
                                    Select Vendor
                                </Form.Label>
                                <Select
                                    options={vendors.map((vendor) => ({
                                        value: vendor._id,
                                        label: vendor.name,
                                    }))}
                                    value={
                                        selectedVendor
                                            ? {
                                                value: selectedVendor,
                                                label: vendors.find(
                                                    (vendor) => vendor._id === selectedVendor,
                                                )?.name,
                                            }
                                            : null
                                    }
                                    onChange={(selectedOption) => {
                                        if (selectedOption) {
                                            handleChange(selectedOption?.value);
                                        } else {
                                            handleChange("");
                                        }
                                    }}
                                    classNamePrefix="react-select"
                                    isClearable
                                    placeholder="Select Vendor"
                                />
                            </Col>
                            <Col md={2}>
                                <Form.Label className="fw-semibold text-secondary">
                                    Select Status
                                </Form.Label>
                                <Form.Select
                                    value={selectedStatus}
                                    onChange={(e) => setSelectedStatus(e.target.value)}
                                >
                                    <option value="">Select Status</option>
                                    <option value="RECEIVED">RECEIVED</option>
                                    <option value="PENDING">PENDING</option>
                                </Form.Select>
                            </Col>
                            <Col md={2}>
                                <Form.Label className="fw-semibold text-secondary">
                                    Sort By
                                </Form.Label>
                                <Form.Select
                                    value={selectedSortBy}
                                    onChange={(e) => setSelectedSortBy(e.target.value)}
                                >
                                    <option value="desc">DESCENDING</option>
                                    <option value="asc">ASCENDING</option>
                                </Form.Select>
                            </Col>
                            <Col md={2}>
                                <Form.Label className="fw-semibold text-secondary">
                                    Start Date <span className="text-danger">*</span>
                                </Form.Label>
                                <ReactDatePicker
                                    selected={startDate}
                                    dateFormat="dd-MM-yyyy"
                                    onChange={(date) => setStartDate(date)}
                                    placeholderText="Select Start Date"
                                    className="form-control"
                                />
                            </Col>
                            <Col md={2}>
                                <Form.Label className="fw-semibold text-secondary">
                                    End Date <span className="text-danger">*</span>
                                </Form.Label>
                                <ReactDatePicker
                                    selected={endDate}
                                    dateFormat="dd-MM-yyyy"
                                    onChange={handleEndDateChange}
                                    placeholderText="Select End Date"
                                    className="form-control"
                                />
                            </Col>
                            <Col md={1}>
                                <Form.Label className="text-white">.</Form.Label>
                                <Button
                                    variant="primary"
                                    className="w-100"
                                    onClick={handleSubmitFilters}
                                    disabled={btnLoading || !startDate || !endDate || endDate < startDate}
                                >
                                    {btnLoading ? (
                                        <Spinner size="sm" animation="border" />
                                    ) : (
                                        "Submit"
                                    )}
                                </Button>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col lg="5" className="mt-2">
                                <div className="input-group w-100">
                                    <input
                                        type="text"
                                        value={searchText}
                                        onChange={(e) => {
                                            setSearchText(e.target.value);
                                            setTouched(true);
                                        }}
                                        className="form-control"
                                        placeholder="Search By ID Number..."
                                    />
                                    <button
                                        className="btn btn-primary w-25"
                                        type="button"
                                        onClick={handleSubmitFilters}
                                    >
                                        {searchBtnLoading ? (
                                            <Spinner size="sm" />
                                        ) : (
                                            <>
                                                {" "}
                                                <i className="ri-search-line"></i> Search{" "}
                                            </>
                                        )}
                                    </button>
                                </div>
                            </Col>
                        </Row>

                        {/* Procurement Listing Table - Same as before */}
                        <Row>
                            <Col>
                                {(purchaseAccess.includes("PurchaseList:get") ||
                                    email === "contact@xpansecafe.com") && (
                                        <div className="table-responsive">
                                            <Table striped bordered hover className="mt-3">
                                                <thead className="table-dark">
                                                    <tr>
                                                        <th style={{ width: "70px" }}>Sr No</th>
                                                        <th style={{ width: "160px" }}>FINANCIAL YEAR</th>
                                                        <th style={{ width: "110px" }}>DATE</th>
                                                        <th style={{ width: "120px" }}>ID NUMBER</th>
                                                        <th style={{ width: "200px" }}>VENDOR NAME</th>
                                                        <th style={{ width: "220px" }}>VENDOR CONTACT</th>
                                                        <th style={{ width: "140px" }}>STATUS</th>
                                                        <th>ACTIONS</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredData?.length === 0 && (
                                                        <tr>
                                                            <td colSpan="8" className="text-center">
                                                                No Data Available For the Selected Dates
                                                            </td>
                                                        </tr>
                                                    )}
                                                    {filteredData.map((row, index) => (
                                                        <tr key={row.id || index}>
                                                            <td>{row.serialNumber || "--------"}</td>
                                                            <td>{row.financialYear || "--------"}</td>
                                                            <td>
                                                                {row.createdAt
                                                                    ? new Date(row.createdAt).toLocaleDateString()
                                                                    : "--------"}
                                                            </td>
                                                            <td>{row.idNumber || "--------"}</td>
                                                            <td>{row.vendor?.name || "--------"}</td>
                                                            <td>
                                                                <div>
                                                                    <a href="#" className="text-decoration-none">
                                                                        {row.vendor?.email || "--------"}
                                                                    </a>
                                                                    <br />
                                                                    <a href="#" className="text-decoration-none">
                                                                        {row.vendor?.phone || "--------"}
                                                                    </a>
                                                                </div>
                                                            </td>
                                                            <td
                                                                className={
                                                                    row.status === "PENDING"
                                                                        ? "text-danger"
                                                                        : "text-success"
                                                                }
                                                            >
                                                                {row.status || "--------"}
                                                                <br />
                                                                {row?.storageLocationName && (
                                                                    <span className="text-muted">[At {row?.storageLocationName || "Not Allocated"}]</span>
                                                                )}

                                                                {row?.outletName && (
                                                                    <span className="text-muted">[At {row?.outletName}, {row?.outletCity}]</span>
                                                                )}
                                                            </td>
                                                            <td className="text-center">
                                                                <Dropdown>
                                                                    <Dropdown.Toggle
                                                                        variant="outline-secondary"
                                                                        size="sm"
                                                                        id="dropdown-actions"
                                                                        className="rounded-pill px-3"
                                                                    >
                                                                        <i className="bi bi-gear-fill me-1"></i>{" "}
                                                                        Actions
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu className="shadow-sm border-0">
                                                                        <Dropdown.Item
                                                                            onClick={() => handleOpenViewModal(row)}
                                                                            className="d-flex align-items-center"
                                                                        >
                                                                            <i className="bi bi-eye me-2 text-primary"></i>
                                                                            <span>View Details</span>
                                                                        </Dropdown.Item>

                                                                        {row.status === "PENDING" && (
                                                                            <>
                                                                                <Dropdown.Divider />
                                                                                {(purchaseAccess.includes(
                                                                                    "PurchaseList:update",
                                                                                ) ||
                                                                                    email === "contact@xpansecafe.com") && (
                                                                                        <Dropdown.Item
                                                                                            onClick={() =>
                                                                                                handleOpenUpdateStatusModal(row)
                                                                                            }
                                                                                            className="d-flex align-items-center"
                                                                                        >
                                                                                            <i className="bi bi-pencil-square me-2 text-warning"></i>
                                                                                            <span>Update Status</span>
                                                                                        </Dropdown.Item>
                                                                                    )}
                                                                                {(purchaseAccess.includes(
                                                                                    "PurchaseList:delete",
                                                                                ) ||
                                                                                    email === "contact@xpansecafe.com") && (
                                                                                        <Dropdown.Item
                                                                                            onClick={() => handleDeleteModal(row)}
                                                                                            className="d-flex align-items-center text-danger"
                                                                                        >
                                                                                            <i className="bi bi-trash3 me-2"></i>
                                                                                            <span>Delete</span>
                                                                                        </Dropdown.Item>
                                                                                    )}
                                                                            </>
                                                                        )}
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>

                                            {/* Pagination */}
                                            {filteredData.length > 0 && (
                                                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 mb-4">
                                                    <div className="text-muted small">
                                                        Showing{" "}
                                                        <span className="fw-semibold">
                                                            {(currentPage - 1) * recordsPerPage + 1}
                                                        </span>{" "}
                                                        to{" "}
                                                        <span className="fw-semibold">
                                                            {Math.min(
                                                                currentPage * recordsPerPage,
                                                                totalRecords,
                                                            )}
                                                        </span>{" "}
                                                        of <span className="fw-semibold">{totalRecords}</span>{" "}
                                                        entries
                                                    </div>

                                                    <div className="d-flex align-items-center gap-3">
                                                        <Form.Group className="d-flex align-items-center">
                                                            <Form.Label className="fw-semibold">
                                                                Records Per Page :
                                                            </Form.Label>
                                                            <Form.Select
                                                                style={{ width: "80px" }}
                                                                size="sm"
                                                                value={recordsPerPage}
                                                                onChange={(e) =>
                                                                    handlerecordsPerPageChange(
                                                                        Number(e.target.value),
                                                                    )
                                                                }
                                                                className="ms-2"
                                                            >
                                                                <option value={10}>10</option>
                                                                <option value={20}>20</option>
                                                                <option value={50}>50</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                        <div className="d-flex align-items-center gap-1">
                                                            <Button
                                                                variant="outline-secondary"
                                                                size="sm"
                                                                onClick={() =>
                                                                    handlePageChange(Math.max(currentPage - 1, 1))
                                                                }
                                                                disabled={currentPage === 1}
                                                                className="px-3"
                                                            >
                                                                <i className="bi bi-chevron-left"></i>
                                                            </Button>

                                                            <div className="mx-2 text-nowrap">
                                                                Page{" "}
                                                                <span className="fw-bold">{currentPage}</span> of{" "}
                                                                <span className="fw-bold">
                                                                    {Math.ceil(totalRecords / recordsPerPage)}
                                                                </span>
                                                            </div>

                                                            <Button
                                                                variant="outline-secondary"
                                                                size="sm"
                                                                onClick={() =>
                                                                    handlePageChange(
                                                                        Math.min(
                                                                            currentPage + 1,
                                                                            Math.ceil(totalRecords / recordsPerPage),
                                                                        ),
                                                                    )
                                                                }
                                                                disabled={
                                                                    currentPage * recordsPerPage >= totalRecords
                                                                }
                                                                className="px-3"
                                                            >
                                                                <i className="bi bi-chevron-right"></i>
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                            </Col>
                        </Row>

                        {/* View Modal - Updated with Charges Display */}
                        {openViewModal ? (
                            <Modal
                                size="lg"
                                show={openViewModal}
                                onHide={() => setOpenViewModal(false)}
                                centered
                                aria-labelledby="vertically-centered-modal"
                                className="procurement-modal"
                                style={{ fontSize: "13px" }}
                            >
                                <Modal.Header
                                    style={{
                                        backgroundColor: "#f8f9fa",
                                        borderBottom: "2px solid #dee2e6",
                                        padding: "0.75rem 1.25rem"
                                    }}
                                    closeButton
                                >
                                    <Modal.Title className="w-100">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <div
                                                    style={{
                                                        width: "6px",
                                                        height: "32px",
                                                        backgroundColor: "#0d6efd",
                                                        borderRadius: "4px",
                                                        marginRight: "12px"
                                                    }}
                                                />
                                                <div>
                                                    <h5 className="fw-bold mb-0" style={{ color: "#1e293b", fontSize: "1.1rem" }}>
                                                        PURCHASE DETAILS
                                                    </h5>
                                                    <small className="text-muted mt-0" style={{ fontSize: "11px" }}>
                                                        ID: {singleProcurementDetails?.idNumber} • {singleProcurementDetails?.financialYear}
                                                    </small>
                                                </div>
                                            </div>

                                            {singleProcurementDetails.status === "PENDING" && (
                                                <Dropdown>
                                                    <Dropdown.Toggle
                                                        variant="primary"
                                                        size="sm"
                                                        style={{ borderRadius: "5px", padding: "0.25rem 1rem", fontSize: "12px" }}
                                                    >
                                                        <i className="bi bi-gear me-1" style={{ fontSize: "11px" }}></i>Actions
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu style={{ fontSize: "12px" }}>
                                                        {(purchaseAccess?.includes("PurchaseList:update") ||
                                                            email === "contact@xpansecafe.com") && (
                                                                <>
                                                                    <Dropdown.Item
                                                                        onClick={() => handleEditModal(singleProcurementDetails)}
                                                                        style={{ padding: "0.4rem 1rem" }}
                                                                    >
                                                                        <i className="bi bi-pencil-square me-2" style={{ fontSize: "11px" }}></i>Edit Procurement
                                                                    </Dropdown.Item>
                                                                </>
                                                            )}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            )}
                                        </div>
                                    </Modal.Title>
                                </Modal.Header>

                                <Modal.Body style={{ padding: "1.25rem", backgroundColor: "#ffffff" }}>
                                    {/* Status Banner */}
                                    <div
                                        className="mb-3 p-2 rounded-3 d-flex align-items-center"
                                        style={{
                                            backgroundColor: singleProcurementDetails?.status === "PENDING"
                                                ? "#fff3cd"
                                                : singleProcurementDetails?.status === "RECEIVED"
                                                    ? "#d1e7dd"
                                                    : "#f8d7da",
                                            borderLeft: `4px solid ${singleProcurementDetails?.status === "PENDING"
                                                ? "#ffc107"
                                                : singleProcurementDetails?.status === "RECEIVED"
                                                    ? "#198754"
                                                    : "#dc3545"
                                                }`
                                        }}
                                    >
                                        <div className="me-2">
                                            <i className={`bi ${singleProcurementDetails?.status === "PENDING"
                                                ? "bi-hourglass-split"
                                                : singleProcurementDetails?.status === "RECEIVED"
                                                    ? "bi-check-circle-fill text-success"
                                                    : "bi-x-circle-fill text-danger"
                                                }`} style={{ fontSize: "1.2rem" }}></i>
                                        </div>
                                        <div>
                                            <h6 className="fw-bold mb-0" style={{ fontSize: "13px" }}>Status: {singleProcurementDetails?.status}</h6>
                                            <small className="text-muted" style={{ fontSize: "11px" }}>Last updated: {new Date().toLocaleDateString()}</small>
                                        </div>
                                    </div>

                                    {/* Two Column Layout */}
                                    <div className="row g-3">
                                        {/* Purchase Details Card */}
                                        <div className="col-md-6">
                                            <div className="card h-100 shadow-sm">
                                                <div className="card-header bg-white py-2">
                                                    <h6 className="fw-bold mb-0" style={{ fontSize: "13px" }}>
                                                        <i className="bi bi-box me-2 text-primary" style={{ fontSize: "12px" }}></i>Purchase Information
                                                    </h6>
                                                </div>
                                                <div className="card-body py-2">
                                                    <div className="row g-2">
                                                        {/* <div className="col-6">
                                                            <small className="text-muted d-block" style={{ fontSize: "11px" }}>ID Number</small>
                                                            <span className="fw-semibold" style={{ fontSize: "12px" }}>{singleProcurementDetails?.idNumber}</span>
                                                        </div> */}
                                                        <div className="col-6">
                                                            <small className="text-muted d-block" style={{ fontSize: "11px" }}>Serial Number</small>
                                                            <span className="fw-semibold" style={{ fontSize: "12px" }}>{singleProcurementDetails?.serialNo}</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <small className="text-muted d-block" style={{ fontSize: "11px" }}>Financial Year</small>
                                                            <span style={{ fontSize: "12px" }}>{singleProcurementDetails?.financialYear}</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <small className="text-muted d-block" style={{ fontSize: "11px" }}>Invoice Number</small>
                                                            <span style={{ fontSize: "12px" }}>{singleProcurementDetails?.idNumber}</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <small className="text-muted d-block" style={{ fontSize: "11px" }}>Invoice Date</small>
                                                            <span style={{ fontSize: "12px" }}>
                                                                {singleProcurementDetails?.invoiceDate
                                                                    ? new Date(singleProcurementDetails.invoiceDate).toLocaleDateString(
                                                                        "en-GB",
                                                                        {
                                                                            day: "2-digit",
                                                                            month: "short",
                                                                            year: "numeric",
                                                                        }
                                                                    )
                                                                    : "-"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Vendor Details Card */}
                                        <div className="col-md-6">
                                            <div className="card h-100 shadow-sm">
                                                <div className="card-header bg-white py-2">
                                                    <h6 className="fw-bold mb-0" style={{ fontSize: "13px" }}>
                                                        <i className="bi bi-shop me-2 text-success" style={{ fontSize: "12px" }}></i>Vendor Information
                                                    </h6>
                                                </div>
                                                <div className="card-body py-2">
                                                    <div className="row g-2">
                                                        <div className="col-12">
                                                            <small className="text-muted d-block" style={{ fontSize: "11px" }}>GSTIN</small>
                                                            <span className="fw-semibold" style={{ fontSize: "12px" }}>{singleProcurementDetails?.vendor?.gstin}</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <small className="text-muted d-block" style={{ fontSize: "11px" }}>Name</small>
                                                            <span style={{ fontSize: "12px" }}>{singleProcurementDetails?.vendor?.name}</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <small className="text-muted d-block" style={{ fontSize: "11px" }}>Phone</small>
                                                            <span style={{ fontSize: "12px" }}>{singleProcurementDetails?.vendor?.phone}</span>
                                                        </div>
                                                        <div className="col-12">
                                                            <small className="text-muted d-block" style={{ fontSize: "11px" }}>Address</small>
                                                            <span style={{ fontSize: "12px" }}>{singleProcurementDetails?.vendor?.address}, {singleProcurementDetails?.vendor?.city} - {singleProcurementDetails?.vendor?.pincode}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Additional Charges Section in View Modal */}
                                    {singleProcurementCharges && (
                                        <div className="mt-3">
                                            <h6 className="fw-bold mb-2" style={{ fontSize: "13px" }}>
                                                <i className="bi bi-cash-stack me-2 text-info" style={{ fontSize: "12px" }}></i>Additional Charges
                                            </h6>
                                            <div className="table-responsive">
                                                <table className="table table-sm table-bordered" style={{ fontSize: "12px" }}>
                                                    <thead>
                                                        <tr className="table-light">
                                                            <th>Charge Name</th>
                                                            <th className="text-end">Amount</th>
                                                            <th className="text-end">Tax %</th>
                                                            <th className="text-end">Tax Amount</th>
                                                            <th className="text-end">Total</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {singleProcurementCharges?.map((charge, idx) => (
                                                            <tr key={idx}>
                                                                <td>{charge.additionalCharge}</td>
                                                                <td className="text-end">₹ {Number(charge.amount || 0).toFixed(2)}</td>
                                                                <td className="text-end">{charge.taxPercent || 0}%</td>
                                                                <td className="text-end">₹ {Number(charge.totalAmount - charge.amount || 0).toFixed(2)}</td>
                                                                <td className="text-end">₹ {Number(charge.totalAmount || 0).toFixed(2)}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                    <tfoot className="table-light">
                                                        <tr>
                                                            <th colSpan="3" className="text-end">Total Charges:</th>
                                                            <th className="text-end">₹ {chargesTotal.totalChargeTax.toFixed(2)}</th>
                                                            <th className="text-end">₹ {chargesTotal.totalChargeTotal.toFixed(2)}</th>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    )}

                                    {/* Procurement Items Section */}
                                    <div className="mt-3">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h6 className="fw-bold mb-0" style={{ fontSize: "13px" }}>
                                                <i className="bi bi-cart me-2 text-warning" style={{ fontSize: "12px" }}></i>Purchase Items
                                            </h6>
                                            {singleProcurementDetails?.status === "PENDING" &&
                                                (purchaseAccess.includes("PurchaseList:add") ||
                                                    email === "contact@xpansecafe.com") && (
                                                    <Button
                                                        variant="warning"
                                                        size="sm"
                                                        style={{ borderRadius: "5px", padding: "0.25rem 1rem", fontSize: "12px" }}
                                                        onClick={() => handleOpenAddProcurementItemModal(singleProcurementDetails)}
                                                    >
                                                        <i className="bi bi-plus-circle me-1" style={{ fontSize: "11px" }}></i>Add Item
                                                    </Button>
                                                )}
                                        </div>

                                        <div className="table-responsive" style={{ maxHeight: "350px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "4px" }}>
                                            <table className="table table-hover table-bordered mb-0" style={{ fontSize: "12px" }}>
                                                <thead className="sticky-top bg-white" style={{ zIndex: 2 }}>
                                                    <tr>
                                                        <th className="text-center" style={{ width: "35px", padding: "0.5rem" }}>Sr No</th>
                                                        <th style={{ padding: "0.5rem" }}>Material</th>
                                                        <th className="text-center" style={{ padding: "0.5rem" }}>Qty</th>
                                                        <th className="text-end" style={{ padding: "0.5rem" }}>Rate</th>
                                                        <th className="text-end" style={{ padding: "0.5rem" }}>Actual Rate</th>
                                                        <th className="text-end" style={{ padding: "0.5rem" }}>Taxable</th>
                                                        <th className="text-end" style={{ padding: "0.5rem" }}>Tax</th>
                                                        <th className="text-end" style={{ padding: "0.5rem" }}>Total</th>
                                                        <th className="text-center" style={{ padding: "0.5rem" }}>Status</th>
                                                        <th className="text-center" style={{ width: "60px", padding: "0.5rem" }}>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {singleProcurementItemsDetails?.map((item, index) => (
                                                        <tr key={item._id}>
                                                            <td className="text-center align-middle" style={{ padding: "0.5rem" }}>{index + 1}</td>
                                                            <td className="align-middle" style={{ padding: "0.5rem" }}>
                                                                <div className="fw-semibold" style={{ fontSize: "12px" }}>{item?.material?.name}</div>
                                                                <small className="text-muted" style={{ fontSize: "10px" }}>{item?.material?.unit}</small>
                                                            </td>
                                                            <td className="text-center align-middle" style={{ padding: "0.5rem" }}>{item?.quantity?.toFixed(3)}</td>
                                                            <td className="text-end align-middle" style={{ padding: "0.5rem" }}>₹ {item?.rate?.toFixed(2)}</td>
                                                            <td className="text-end align-middle" style={{ padding: "0.5rem" }}>₹ {item?.actualRate?.toFixed(2)}</td>
                                                            <td className="text-end align-middle" style={{ padding: "0.5rem" }}>₹ {item?.taxable?.toFixed(2)}</td>
                                                            <td className="text-end align-middle" style={{ padding: "0.5rem" }}>
                                                                ₹ {item?.taxAmount?.toFixed(2)}
                                                            </td>
                                                            <td className="text-end align-middle fw-bold" style={{ padding: "0.5rem" }}>
                                                                ₹ {item?.grandTotal?.toFixed(2)}
                                                            </td>
                                                            <td className="text-center align-middle" style={{ padding: "0.5rem" }}>
                                                                <span className={`badge ${item?.status === 'PENDING' ? 'bg-warning' :
                                                                    item?.status === 'APPROVED' ? 'bg-success' : 'bg-secondary'
                                                                    }`} style={{ fontSize: "10px" }}>
                                                                    {item?.status}
                                                                </span>
                                                                <br />
                                                                {(item?.outletName || item?.storageLocationName) && (
                                                                    <small className="text-muted" style={{ fontSize: "9px" }}>
                                                                        at {item?.outletName || item?.storageLocationName}
                                                                    </small>
                                                                )}
                                                            </td>
                                                            <td className="text-center align-middle position-relative" style={{ padding: "0.5rem" }}>
                                                                <Dropdown>
                                                                    <Dropdown.Toggle
                                                                        variant={item.status === "PENDING" ? "outline-primary" : "secondary"}
                                                                        size="sm"
                                                                        disabled={item.status !== "PENDING"}
                                                                        style={{ padding: "0.15rem 0.5rem", fontSize: "11px" }}
                                                                    >
                                                                        <i className="bi bi-three-dots"></i>
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu
                                                                        style={{
                                                                            fontSize: "11px",
                                                                            minWidth: "140px",
                                                                            zIndex: 1050,
                                                                            position: "absolute",
                                                                            inset: "auto auto 0px 0px",
                                                                            transform: "translate(-100%, -100%)",
                                                                            margin: "0px"
                                                                        }}
                                                                    >
                                                                        {item.status === "PENDING" && (
                                                                            <>
                                                                                {purchaseAccess.includes("PurchaseList:update") && (
                                                                                    <Dropdown.Item
                                                                                        onClick={() => handleOpenProcurementItemEditModal(item)}
                                                                                        style={{ padding: "0.3rem 1rem" }}
                                                                                    >
                                                                                        <i className="bi bi-pencil me-2" style={{ fontSize: "10px" }}></i>Edit
                                                                                    </Dropdown.Item>
                                                                                )}
                                                                                {purchaseAccess.includes("PurchaseList:delete") && (
                                                                                    <Dropdown.Item
                                                                                        onClick={() => handleOpenProcurementItemDeleteModal(item)}
                                                                                        style={{ padding: "0.3rem 1rem" }}
                                                                                    >
                                                                                        <i className="bi bi-trash me-2 text-danger" style={{ fontSize: "10px" }}></i>Delete
                                                                                    </Dropdown.Item>
                                                                                )}
                                                                                <Dropdown.Item
                                                                                    onClick={() => handleOpenProcurementItemUpdateStatus(item)}
                                                                                    style={{ padding: "0.3rem 1rem" }}
                                                                                >
                                                                                    <i className="bi bi-arrow-repeat me-2" style={{ fontSize: "10px" }}></i>Update Status
                                                                                </Dropdown.Item>
                                                                            </>
                                                                        )}
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Summary Card */}
                                        <div className="card mt-3 bg-light">
                                            <div className="card-body py-2 px-3">
                                                <div className="row justify-content-end">
                                                    <div className="col-md-5">
                                                        <table className="table table-sm table-borderless mb-0" style={{ fontSize: "12px" }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ padding: "0.25rem" }}>Taxable Amount:</td>
                                                                    <td className="text-end fw-semibold" style={{ padding: "0.25rem" }}>₹ {totals.totalTaxable.toFixed(2)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ padding: "0.25rem" }}>Tax Amount:</td>
                                                                    <td className="text-end fw-semibold" style={{ padding: "0.25rem" }}>₹ {totals.totalTaxAmount.toFixed(2)}</td>
                                                                </tr>
                                                                {singleProcurementCharges && singleProcurementCharges.length > 0 && (
                                                                    <>
                                                                        <tr>
                                                                            <td style={{ padding: "0.25rem" }}>Additional Charges:</td>
                                                                            <td className="text-end fw-semibold" style={{ padding: "0.25rem" }}>₹ {chargesTotal.totalChargeAmount.toFixed(2)}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style={{ padding: "0.25rem" }}>Charges Tax Amount:</td>
                                                                            <td className="text-end fw-semibold" style={{ padding: "0.25rem" }}>₹ {chargesTotal.totalChargeTax.toFixed(2)}</td>
                                                                        </tr>
                                                                    </>
                                                                )}
                                                                <tr>
                                                                    <td colSpan="2" style={{ padding: "0.1rem" }}>
                                                                        <hr className="my-1" />
                                                                    </td>
                                                                </tr>
                                                                <tr className="fw-bold">
                                                                    <td style={{ padding: "0.25rem" }}>Grand Total:</td>
                                                                    <td className="text-end text-primary" style={{ padding: "0.25rem", fontSize: "14px" }}>
                                                                        ₹ {(totals.totalGrandTotal + chargesTotal.totalChargeTotal).toFixed(2)}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Modal.Body>

                                <Modal.Footer style={{ backgroundColor: "#f8f9fa", borderTop: "2px solid #dee2e6", padding: "0.75rem 1.25rem" }}>
                                    {singleProcurementDetails?.scannedInvoice && (
                                        <Button
                                            variant="outline-primary"
                                            href={singleProcurementDetails.scannedInvoice}
                                            size="sm"
                                            style={{ borderRadius: "5px", fontSize: "12px", padding: "0.3rem 1.2rem" }}
                                        >
                                            <i className="bi bi-download me-1" style={{ fontSize: "11px" }}></i>Download Invoice
                                        </Button>
                                    )}
                                    <Button
                                        variant="secondary"
                                        onClick={() => setOpenViewModal(false)}
                                        size="sm"
                                        style={{ borderRadius: "5px", fontSize: "12px", padding: "0.3rem 1.5rem" }}
                                    >
                                        Close
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        ) : null}

                        {/* Edit Modal - Updated with Charges Management */}
                        {openEditModal && (
                            <Modal
                                centered
                                show={openEditModal}
                                onHide={() => setOpenEditModal(false)}
                                size="lg"
                            >

                                <Modal.Header closeButton>
                                    <Modal.Title className="fs-6">
                                        EDIT PURCHASE DETAILS
                                    </Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={handleEditSubmit}>
                                    <Modal.Body>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">
                                                        Select Vendor <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        size="sm"
                                                        onChange={handleEditChange}
                                                        value={editedData.vendor}
                                                        name="vendor"
                                                        className="mb-3"
                                                    >
                                                        <option>Select Vendor</option>
                                                        {vendors &&
                                                            vendors.map((rm) => (
                                                                <option key={rm._id} value={rm._id}>
                                                                    {rm.name}
                                                                </option>
                                                            ))}
                                                    </Form.Select>
                                                    <div className="text-danger">
                                                        {editValidationErrors.vendor}
                                                    </div>
                                                </Form.Group>
                                            </Col>

                                            <Col md={5}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        ID Number <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="ID Number"
                                                        name="idNumber"
                                                        value={editedData.idNumber}
                                                        onChange={handleIdNumberChange}
                                                    />
                                                    <div className="text-danger">
                                                        {editValidationErrors.idNumber}
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3 d-flex flex-column">
                                                    <Form.Label className="fw-semibold">
                                                        Invoice Date <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <ReactDatePicker
                                                        selected={editedData.invoiceDate ? new Date(editedData.invoiceDate) : null}
                                                        dateFormat="dd-MM-yyyy"
                                                        onChange={(date) => {
                                                            setEditedData(prev => ({
                                                                ...prev,
                                                                invoiceDate: date
                                                            }));
                                                            setEditValidationErrors((prevErrors) => ({
                                                                ...prevErrors,
                                                                invoiceDate: "",
                                                            }));
                                                        }}
                                                        placeholderText="Select Invoice Date"
                                                        className="form-control"
                                                        required
                                                    />
                                                    <div className="text-danger">
                                                        {editValidationErrors.invoiceDate}
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Scanned Invoice
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="file"
                                                        onChange={handleFileChange}
                                                    />
                                                    <div className="text-danger">
                                                        {editValidationErrors.scannedInvoice}
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        {/* Additional Charges Section in Edit Modal */}
                                        <div className="d-flex justify-content-between align-items-center mb-2 mt-3">
                                            <h6 className="fw-semibold mb-0" style={{ fontSize: '0.9rem' }}>Additional Charges</h6>
                                            <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                onClick={handleAddChargeInEdit}
                                            >
                                                <i className="bi bi-plus-lg me-1"></i> Add Charge
                                            </Button>
                                        </div>

                                        {(editedData.charges || []).length > 0 && (
                                            <div className="mb-3">
                                                {(editedData.charges || []).map((charge, index) => (
                                                    <Row key={index} className="g-2 mb-2 align-items-end">
                                                        <Col md={4}>
                                                            <Form.Group>
                                                                <Form.Label style={{ fontSize: '0.8rem' }}>Charge Name</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="e.g., Freight"
                                                                    value={charge.additionalCharge || ""}
                                                                    onChange={(e) => handleChargeChangeInEdit(index, 'additionalCharge', e.target.value)}
                                                                    size="sm"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={2}>
                                                            <Form.Group>
                                                                <Form.Label style={{ fontSize: '0.8rem' }}>Tax %</Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    step="any"
                                                                    placeholder="0"
                                                                    value={charge.taxPercent || ""}
                                                                    onChange={(e) => handleChargeChangeInEdit(index, 'taxPercent', e.target.value)}
                                                                    size="sm"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={2}>
                                                            <Form.Group>
                                                                <Form.Label style={{ fontSize: '0.8rem' }}>Amount</Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    step="any"
                                                                    placeholder="0.00"
                                                                    value={charge.amount || ""}
                                                                    onChange={(e) => handleChargeChangeInEdit(index, 'amount', e.target.value)}
                                                                    size="sm"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={3}>
                                                            <Form.Group>
                                                                <Form.Label style={{ fontSize: '0.8rem' }}>Total</Form.Label>
                                                                <Form.Control
                                                                    disabled
                                                                    type="text"
                                                                    value={`₹${(charge.totalAmount || 0).toFixed(2)}`}
                                                                    size="sm"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={1} className="d-flex align-items-end">
                                                            <Button
                                                                variant="outline-danger"
                                                                size="sm"
                                                                onClick={() => handleRemoveChargeInEdit(index)}
                                                            >
                                                                <i className="bi bi-dash-lg"></i>
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                ))}
                                            </div>
                                        )}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button
                                            type="submit"
                                            variant="primary"
                                            disabled={isEditBtnLoading}
                                        >
                                            {isEditBtnLoading ? (
                                                <Spinner size="sm" animation="border" />
                                            ) : (
                                                "SAVE CHANGES"
                                            )}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        )}

                        {/* Rest of the modals remain the same (Delete, Update Status, Add Item, Edit Item, Delete Item, Update Item Status, Add Material) */}
                        {openDeleteModal && (
                            <Modal
                                centered
                                show={openDeleteModal}
                                onHide={() => setOpenDeleteModal(false)}
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title className="fs-6">DELETE PROCUREMENT</Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={handleDeleteProcurement}>
                                    <Modal.Body>
                                        Are you sure you want to delete this procurement?
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button
                                            variant="warning"
                                            onClick={() => setOpenDeleteModal(false)}
                                            style={{ borderRadius: "18px" }}
                                        >
                                            Close
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="danger"
                                            disabled={isDeleteBtnLoading}
                                        >
                                            {isDeleteBtnLoading ? (
                                                <Spinner size="sm" animation="border" />
                                            ) : (
                                                "CONFIRM"
                                            )}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        )}





















                        {openUpdateStatusModal ? (
                            <Modal
                                show={openUpdateStatusModal}
                                onHide={() => {
                                    resetModalFields();
                                    setOpenUpdateStatusModal(false);
                                }}
                                centered
                                aria-labelledby="vertically-centered-modal"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="vertically-centered-modal" className="fs-5 ">
                                        UPDATE STATUS OF THE PROCUREMENT
                                    </Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={handleProcurementUpdateStatus}>
                                    <Modal.Body>
                                        <p className="fw-semibold text-muted">
                                            Are you sure you want to update the status of this
                                            procurement?
                                        </p>
                                        <span className="text-success fw-semibold mt-1">
                                            Please select a storage location or outlet before confirming.
                                        </span>

                                        {/* Select Storage Location Field */}
                                        <Col md={12} className="mt-3">
                                            <Form.Label className="fw-semibold text-muted">
                                                Select Storage Location{" "}
                                                <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Select
                                                components={animatedComponents}
                                                id="selectField"
                                                name="storage_location"
                                                value={storageLocationList
                                                    .map((storage) => ({
                                                        value: storage?._id,
                                                        label: `${storage?.name} -> ${storage?.city}, ${storage?.state}`,
                                                    }))
                                                    .find(
                                                        (option) =>
                                                            option.value === selectedStorageLocation,
                                                    )}
                                                onChange={(selectedOption) =>
                                                    setSelectedStorageLocation(
                                                        selectedOption ? selectedOption.value : "",
                                                    )
                                                }
                                                options={storageLocationList.map((storage) => ({
                                                    value: storage?._id,
                                                    label: `${storage?.name} -> ${storage?.city}, ${storage?.state}`,
                                                }))}
                                                placeholder="Select a Storage Location"
                                                isClearable
                                                isDisabled={selectedOutlet}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        borderColor: selectedStorageLocation
                                                            ? base.borderColor
                                                            : base.borderColor,
                                                    }),
                                                }}
                                            />
                                            {/* {!selectedStorageLocation && (
                                                <span
                                                    className="text-danger d-block"
                                                    style={{ fontSize: "13px" }}
                                                >
                                                    Storage location is required.
                                                </span>
                                            )} */}
                                        </Col>

                                        <Col md={12} className="mt-3">
                                            <Form.Label className="fw-semibold text-muted">
                                                Select Outlet {" "}
                                                <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Select
                                                components={animatedComponents}
                                                id="selectField"
                                                name="outlet"
                                                value={outlets
                                                    .map((out) => ({
                                                        value: out?._id,
                                                        label: `${out?.name} -> ${out?.city}, ${out?.state}`,
                                                    }))
                                                    .find(
                                                        (option) =>
                                                            option.value === selectedOutlet,
                                                    )}
                                                onChange={(selectedOption) =>
                                                    setSelectedOutlet(
                                                        selectedOption ? selectedOption.value : "",
                                                    )
                                                }
                                                options={outlets.map((out) => ({
                                                    value: out?._id,
                                                    label: `${out?.name} -> ${out?.city}, ${out?.state}`,
                                                }))}
                                                placeholder="Select a Outlet"
                                                isClearable
                                                isDisabled={selectedStorageLocation}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        borderColor: selectedOutlet
                                                            ? base.borderColor
                                                            : base.borderColor,
                                                    }),
                                                }}
                                            />
                                        </Col>
                                    </Modal.Body>

                                    <Modal.Footer>
                                        <Button
                                            variant="warning"
                                            onClick={() => setOpenUpdateStatusModal(false)}
                                        >
                                            Close
                                        </Button>
                                        <Button type="submit">
                                            {isStatusBtnLoading ? <Spinner size="sm" /> : "CONFIRM"}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        ) : null}

                        {openAddProcurementItemModal ? (
                            <Modal
                                size="lg"
                                show={openAddProcurementItemModal}
                                onHide={handleCloseAddProcurementItemModal}
                                centered
                                aria-labelledby="vertically-centered-modal"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="vertically-centered-modal" className="fs-6">
                                        ADD NEW PURCHASE ITEM
                                    </Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={addProcurementItem}>
                                    <Modal.Body>
                                        <Row>
                                            <Col>
                                                <div className="mb-3">
                                                    <Form.Label>
                                                        Select Material <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Select
                                                        size="sm"
                                                        name="material"
                                                        className="mb-3"
                                                        options={rawMaterialOptions}
                                                        value={
                                                            rawMaterialOptions.find(
                                                                (rm) =>
                                                                    rm.value ===
                                                                    addProcurementItemDetails.material,
                                                            ) || null
                                                        }
                                                        onChange={async (selectedOption) => {
                                                            const materialId = selectedOption?.value || "";

                                                            // Update selected material
                                                            handleAddProcurementItemChanges(
                                                                "material",
                                                                materialId
                                                            );

                                                            if (materialId) {
                                                                try {
                                                                    const headers = {
                                                                        Authorization: `Bearer ${accessToken}`,
                                                                    };
                                                                    const response = await axios.get(
                                                                        `raw-material?_id=${materialId}`,
                                                                        { headers },
                                                                    );

                                                                    if (response?.data?.status === true) {
                                                                        const raw = response?.data?.data?.rawMaterials;
                                                                        const taxPercent = raw?.taxPercent || 0;
                                                                        const unit = raw?.unit || "";

                                                                        // Update the item fields
                                                                        setAddProcurementItemDetails(prev => ({
                                                                            ...prev,
                                                                            taxPercent,
                                                                            unit,
                                                                        }));
                                                                    }
                                                                } catch (error) {
                                                                    console.error(
                                                                        "Error fetching raw material details:",
                                                                        error,
                                                                    );
                                                                    toast.error(
                                                                        "Failed to fetch raw material details",
                                                                    );
                                                                }
                                                            } else {
                                                                // If cleared, reset those fields
                                                                setAddProcurementItemDetails(prev => ({
                                                                    ...prev,
                                                                    taxPercent: 0,
                                                                    unit: "",
                                                                }));
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Quantity <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        step="any"
                                                        type="number"
                                                        placeholder="Quantity"
                                                        className="no-arrows"
                                                        name="quantity"
                                                        value={addProcurementItemDetails.quantity}
                                                        onChange={(e) => {
                                                            handleAddProcurementItemChanges(e);

                                                            // Recalculate when quantity changes
                                                            const { rate, quantity, taxPercent, unit, actualRate } = addProcurementItemDetails;
                                                            const qty = parseFloat(e.target.value) || 0;
                                                            const actRate = parseFloat(actualRate) || 0;

                                                            if (unit === "GRAMS" || unit === "ML") {
                                                                // Calculate rate based on actualRate and quantity
                                                                const calculatedRate = actRate > 0 && qty > 0
                                                                    ? actRate / qty
                                                                    : 0;

                                                                const { taxable, taxAmount, grandTotal } = calculateTaxAmount(
                                                                    calculatedRate,
                                                                    qty,
                                                                    taxPercent,
                                                                    unit,
                                                                    actRate
                                                                );

                                                                setAddProcurementItemDetails(prev => ({
                                                                    ...prev,
                                                                    quantity: qty,
                                                                    rate: Number(calculatedRate.toFixed(5)),
                                                                    taxable,
                                                                    taxAmount,
                                                                    grandTotal
                                                                }));
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Unit <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Unit"
                                                        className="no-arrows"
                                                        name="unit"
                                                        value={addProcurementItemDetails.unit}
                                                        disabled
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col>
                                                <div className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Actual Rate (₹) <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        step="any"
                                                        type="number"
                                                        placeholder="0.00"
                                                        name="actualRate"
                                                        value={addProcurementItemDetails.actualRate || ""}
                                                        onChange={(e) => {
                                                            const actualRate = parseFloat(e.target.value) || 0;
                                                            const quantity = parseFloat(addProcurementItemDetails.quantity) || 0;
                                                            const unit = addProcurementItemDetails.unit;
                                                            const taxPercent = addProcurementItemDetails.taxPercent || 0;

                                                            let rate = actualRate;

                                                            // Calculate rate based on unit
                                                            if ((unit === "GRAMS" || unit === "ML") && actualRate > 0 && quantity > 0) {
                                                                rate = actualRate / quantity;
                                                            }

                                                            rate = Number(rate.toFixed(5));

                                                            const { taxable, taxAmount, grandTotal } = calculateTaxAmount(
                                                                rate,
                                                                quantity,
                                                                taxPercent,
                                                                unit,
                                                                actualRate
                                                            );

                                                            setAddProcurementItemDetails(prev => ({
                                                                ...prev,
                                                                actualRate,
                                                                rate,
                                                                taxable,
                                                                taxAmount,
                                                                grandTotal
                                                            }));
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Rate (₹) <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        step="any"
                                                        type="number"
                                                        placeholder="0.00"
                                                        name="rate"
                                                        value={addProcurementItemDetails.rate || ""}
                                                        onChange={(e) => {
                                                            const rate = parseFloat(e.target.value) || 0;
                                                            const quantity = parseFloat(addProcurementItemDetails.quantity) || 0;
                                                            const unit = addProcurementItemDetails.unit;
                                                            const taxPercent = addProcurementItemDetails.taxPercent || 0;

                                                            let actualRate = rate;

                                                            // Calculate actualRate based on unit
                                                            if (unit === "GRAMS" || unit === "ML") {
                                                                actualRate = rate * quantity;
                                                            }

                                                            const { taxable, taxAmount, grandTotal } = calculateTaxAmount(
                                                                rate,
                                                                quantity,
                                                                taxPercent,
                                                                unit,
                                                                actualRate
                                                            );

                                                            setAddProcurementItemDetails(prev => ({
                                                                ...prev,
                                                                rate,
                                                                actualRate: Number(actualRate.toFixed(2)),
                                                                taxable,
                                                                taxAmount,
                                                                grandTotal
                                                            }));
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col>
                                                <div className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Tax Percent
                                                    </Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        type="number"
                                                        step="any"
                                                        placeholder="Tax Percent"
                                                        className="no-arrows"
                                                        name="taxPercent"
                                                        value={addProcurementItemDetails.taxPercent}
                                                        disabled
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Taxable
                                                    </Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        type="number"
                                                        step="any"
                                                        placeholder="In Rupees"
                                                        className="no-arrows"
                                                        name="taxable"
                                                        value={parseFloat(
                                                            addProcurementItemDetails.taxable,
                                                        )?.toFixed(2) || "0.00"}
                                                        disabled
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Tax Amount
                                                    </Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        type="number"
                                                        step="any"
                                                        placeholder="In Rupees"
                                                        className="no-arrows"
                                                        name="taxAmount"
                                                        value={parseFloat(
                                                            addProcurementItemDetails.taxAmount,
                                                        )?.toFixed(2) || "0.00"}
                                                        disabled
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Grand Total
                                                    </Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        type="number"
                                                        step="any"
                                                        placeholder="In Rupees"
                                                        className="no-arrows"
                                                        name="grandTotal"
                                                        value={parseFloat(
                                                            addProcurementItemDetails?.grandTotal || 0
                                                        ).toFixed(2)}
                                                        disabled
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button
                                            type="submit"
                                            disabled={
                                                !addProcurementItemDetails.material ||
                                                !addProcurementItemDetails.quantity ||
                                                !addProcurementItemDetails.actualRate
                                            }
                                        >
                                            {isAddItemBtnLoading ? (
                                                <Spinner size="sm" />
                                            ) : (
                                                "ADD PURCHASE ITEM"
                                            )}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        ) : null}

                        <Modal
                            size="lg"
                            show={openProcurementItemEditModal}
                            onHide={() => setOpenProcurementItemEditModal(false)}
                            centered
                            aria-labelledby="vertically-centered-modal"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="vertically-centered-modal" className="fs-6">
                                    EDIT PURCHASE ITEM DETAILS
                                </Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleEditProcurementItemSubmit}>
                                <Modal.Body>
                                    <Row>
                                        <Col md={4}>
                                            <Form.Label>
                                                Select Material <span className="text-danger">*</span>
                                            </Form.Label>
                                            <div className="mb-3">
                                                <Select
                                                    size="sm"
                                                    name="material"
                                                    className="mb-3"
                                                    options={rawMaterialOptions}
                                                    value={
                                                        rawMaterialOptions.find(
                                                            (rm) =>
                                                                rm.value ===
                                                                editProcurementItemDetails.material,
                                                        ) || null
                                                    }
                                                    onChange={async (selectedOption) => {
                                                        const materialId = selectedOption?.value || "";

                                                        // Update selected material
                                                        handleEditProcurementItemChange(
                                                            "material",
                                                            materialId
                                                        );

                                                        if (materialId) {
                                                            try {
                                                                const headers = {
                                                                    Authorization: `Bearer ${accessToken}`,
                                                                };
                                                                const response = await axios.get(
                                                                    `raw-material?_id=${materialId}`,
                                                                    { headers },
                                                                );

                                                                if (response?.data?.status === true) {
                                                                    const raw = response?.data?.data?.rawMaterials;
                                                                    const taxPercent = raw?.taxPercent || 0;
                                                                    const unit = raw?.unit || "";

                                                                    // Calculate actualRate from rate and quantity
                                                                    const rate = parseFloat(editProcurementItemDetails.rate) || 0;
                                                                    const quantity = parseFloat(editProcurementItemDetails.quantity) || 0;
                                                                    let actualRate = rate;

                                                                    if (unit === "GRAMS" || unit === "ML") {
                                                                        actualRate = rate * quantity;
                                                                    }

                                                                    setEditProcurementItemDetails(prev => ({
                                                                        ...prev,
                                                                        material: materialId,
                                                                        taxPercent,
                                                                        unit,
                                                                        actualRate: Number(actualRate.toFixed(2)),
                                                                    }));
                                                                }
                                                            } catch (error) {
                                                                console.error(
                                                                    "Error fetching raw material details:",
                                                                    error,
                                                                );
                                                                toast.error(
                                                                    "Failed to fetch raw material details",
                                                                );
                                                            }
                                                        } else {
                                                            // If cleared, reset those fields
                                                            setEditProcurementItemDetails(prev => ({
                                                                ...prev,
                                                                taxPercent: 0,
                                                                unit: "",
                                                                actualRate: 0,
                                                            }));
                                                        }
                                                    }}
                                                />
                                                <div className="text-danger">
                                                    {editProcurementItemValidationErrors.material}
                                                </div>
                                            </div>
                                        </Col>

                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label>
                                                    Quantity <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    min={1}
                                                    type="number"
                                                    step="any"
                                                    placeholder="Quantity"
                                                    className="no-arrows"
                                                    name="quantity"
                                                    value={editProcurementItemDetails.quantity}
                                                    onChange={(e) => {
                                                        const quantity = parseFloat(e.target.value) || 0;
                                                        const rate = parseFloat(editProcurementItemDetails.rate) || 0;
                                                        const unit = editProcurementItemDetails.unit;
                                                        const taxPercent = editProcurementItemDetails.taxPercent || 0;

                                                        let actualRate = editProcurementItemDetails.actualRate || 0;

                                                        // Recalculate actualRate based on new quantity
                                                        if (unit === "GRAMS" || unit === "ML") {
                                                            actualRate = rate * quantity;
                                                        }

                                                        const { taxable, taxAmount, grandTotal } = calculateTaxAmount(
                                                            rate,
                                                            quantity,
                                                            taxPercent,
                                                            unit,
                                                            actualRate
                                                        );

                                                        setEditProcurementItemDetails(prev => ({
                                                            ...prev,
                                                            quantity,
                                                            actualRate: Number(actualRate.toFixed(2)),
                                                            taxable,
                                                            taxAmount,
                                                            grandTotal
                                                        }));
                                                    }}
                                                />
                                                <div className="text-danger">
                                                    {editProcurementItemValidationErrors.quantity}
                                                </div>
                                            </div>
                                        </Col>

                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label>
                                                    Unit
                                                </Form.Label>
                                                <Form.Control
                                                    disabled
                                                    type="text"
                                                    placeholder="Unit"
                                                    className="no-arrows"
                                                    name="unit"
                                                    value={editProcurementItemDetails.unit}
                                                />
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label>
                                                    Actual Rate (₹) <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    step="any"
                                                    type="number"
                                                    placeholder="0.00"
                                                    name="actualRate"
                                                    value={editProcurementItemDetails.actualRate || ""}
                                                    onChange={(e) => {
                                                        const actualRate = parseFloat(e.target.value) || 0;
                                                        const quantity = parseFloat(editProcurementItemDetails.quantity) || 0;
                                                        const unit = editProcurementItemDetails.unit;
                                                        const taxPercent = editProcurementItemDetails.taxPercent || 0;

                                                        let rate = actualRate;

                                                        // Calculate rate based on unit
                                                        if ((unit === "GRAMS" || unit === "ML") && actualRate > 0 && quantity > 0) {
                                                            rate = actualRate / quantity;
                                                        }

                                                        rate = Number(rate.toFixed(5));

                                                        const { taxable, taxAmount, grandTotal } = calculateTaxAmount(
                                                            rate,
                                                            quantity,
                                                            taxPercent,
                                                            unit,
                                                            actualRate
                                                        );

                                                        setEditProcurementItemDetails(prev => ({
                                                            ...prev,
                                                            actualRate,
                                                            rate,
                                                            taxable,
                                                            taxAmount,
                                                            grandTotal
                                                        }));
                                                    }}
                                                />
                                            </div>
                                        </Col>

                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label>
                                                    Rate (₹) <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    step="any"
                                                    type="number"
                                                    placeholder="0.00"
                                                    name="rate"
                                                    value={editProcurementItemDetails.rate || ""}
                                                    onChange={(e) => {
                                                        const rate = parseFloat(e.target.value) || 0;
                                                        const quantity = parseFloat(editProcurementItemDetails.quantity) || 0;
                                                        const unit = editProcurementItemDetails.unit;
                                                        const taxPercent = editProcurementItemDetails.taxPercent || 0;

                                                        let actualRate = rate;

                                                        // Calculate actualRate based on unit
                                                        if (unit === "GRAMS" || unit === "ML") {
                                                            actualRate = rate * quantity;
                                                        }

                                                        const { taxable, taxAmount, grandTotal } = calculateTaxAmount(
                                                            rate,
                                                            quantity,
                                                            taxPercent,
                                                            unit,
                                                            actualRate
                                                        );

                                                        setEditProcurementItemDetails(prev => ({
                                                            ...prev,
                                                            rate,
                                                            actualRate: Number(actualRate.toFixed(2)),
                                                            taxable,
                                                            taxAmount,
                                                            grandTotal
                                                        }));
                                                    }}
                                                />
                                                <div className="text-danger">
                                                    {editProcurementItemValidationErrors.rate}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label>
                                                    Tax Percent
                                                </Form.Label>
                                                <Form.Control
                                                    min={0}
                                                    step="any"
                                                    type="number"
                                                    placeholder="Tax Percent"
                                                    className="no-arrows"
                                                    name="taxPercent"
                                                    value={editProcurementItemDetails.taxPercent}
                                                    disabled
                                                />
                                            </div>
                                        </Col>

                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label>
                                                    Taxable
                                                </Form.Label>
                                                <Form.Control
                                                    min={0}
                                                    step="any"
                                                    type="number"
                                                    placeholder="In Rupees"
                                                    className="no-arrows"
                                                    name="taxable"
                                                    value={editProcurementItemDetails.taxable?.toFixed(2) || "0.00"}
                                                    disabled
                                                />
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label>
                                                    Tax Amount
                                                </Form.Label>
                                                <Form.Control
                                                    min={0}
                                                    step="any"
                                                    type="number"
                                                    placeholder="In Rupees"
                                                    className="no-arrows"
                                                    name="taxAmount"
                                                    value={editProcurementItemDetails.taxAmount?.toFixed(
                                                        2,
                                                    ) || "0.00"}
                                                    disabled
                                                />
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label>
                                                    Grand Total
                                                </Form.Label>
                                                <Form.Control
                                                    min={0}
                                                    step="any"
                                                    type="number"
                                                    placeholder="In Rupees"
                                                    className="no-arrows"
                                                    name="quantity"
                                                    value={editProcurementItemDetails.grandTotal?.toFixed(
                                                        2,
                                                    ) || "0.00"}
                                                    disabled
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button type="submit">
                                        {isEditItemBtnLoading ? (
                                            <Spinner size="sm" />
                                        ) : (
                                            "SAVE CHANGES"
                                        )}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>

                        {openProcurementItemDeleteModal && (
                            <Modal
                                show={openProcurementItemDeleteModal}
                                onHide={() => setOpenProcurementDeleteModal(false)}
                                centered
                                aria-labelledby="vertically-centered-modal"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="vertically-centered-modal" className="fs-6">
                                        DELETE PURCHASE ITEM
                                    </Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={handleDeleteProcurementItems}>
                                    <Modal.Body>
                                        Are you sure you want to delete this purchase Item?
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button
                                            variant="warning"
                                            onClick={() => setOpenProcurementDeleteModal(false)}
                                            style={{
                                                background: "#ef9a9a",
                                                outline: "none",
                                                border: "none",
                                            }}
                                        >
                                            Close
                                        </Button>
                                        <Button type="submit">
                                            {isItemDeleteBtnLoading ? (
                                                <Spinner size="sm" />
                                            ) : (
                                                "CONFIRM"
                                            )}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        )}

                        {openUpdateStatusItemModal && (
                            <Modal
                                show={openUpdateStatusItemModal}
                                onHide={() => {
                                    resetModalFields()
                                    setOpenUpdateStatusItemModal(false)
                                }
                                }
                                centered
                                aria-labelledby="vertically-centered-modal"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="vertically-centered-modal" className="fs-6">
                                        UPDATE STATUS OF THE PURCHASE ITEM
                                    </Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={handleProcurementItemUpdateStatus}>
                                    <Modal.Body>
                                        <p>
                                            Are you sure you want to update the status of this
                                            purchase Item?
                                        </p>

                                        {/* Storage Location Field */}
                                        <Col md={12} className="mt-1">
                                            <Form.Label className="fw-semibold text-muted">
                                                Select Storage Location{" "}
                                                <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Select
                                                components={animatedComponents}
                                                id="selectField"
                                                name="storage_location"
                                                value={storageLocationList
                                                    .map((storage) => ({
                                                        value: storage?._id,
                                                        label: `${storage?.name} -> ${storage?.city}, ${storage?.state}`,
                                                    }))
                                                    .find(
                                                        (option) =>
                                                            option.value === selectedStorageLocation,
                                                    )}
                                                onChange={(selectedOption) =>
                                                    setSelectedStorageLocation(
                                                        selectedOption ? selectedOption.value : "",
                                                    )
                                                }
                                                options={storageLocationList.map((storage) => ({
                                                    value: storage?._id,
                                                    label: `${storage?.name} -> ${storage?.city}, ${storage?.state}`,
                                                }))}
                                                placeholder="Select a Storage Location"
                                                isClearable
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        borderColor: selectedStorageLocation
                                                            ? base.borderColor
                                                            : base.borderColor,
                                                    }),
                                                }}
                                            />

                                        </Col>
                                        <Col md={12} className="mt-3">
                                            <Form.Label className="fw-semibold text-muted">
                                                Select Outlet {" "}
                                                <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Select
                                                components={animatedComponents}
                                                id="selectField"
                                                name="outlet"
                                                value={outlets
                                                    .map((out) => ({
                                                        value: out?._id,
                                                        label: `${out?.name} -> ${out?.city}, ${out?.state}`,
                                                    }))
                                                    .find(
                                                        (option) =>
                                                            option.value === selectedOutlet,
                                                    )}
                                                onChange={(selectedOption) =>
                                                    setSelectedOutlet(
                                                        selectedOption ? selectedOption.value : "",
                                                    )
                                                }
                                                options={outlets.map((out) => ({
                                                    value: out?._id,
                                                    label: `${out?.name} -> ${out?.city}, ${out?.state}`,
                                                }))}
                                                placeholder="Select a Outlet"
                                                isClearable
                                                isDisabled={selectedStorageLocation}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        borderColor: selectedOutlet
                                                            ? base.borderColor
                                                            : base.borderColor,
                                                    }),
                                                }}
                                            />
                                        </Col>
                                    </Modal.Body>

                                    <Modal.Footer>
                                        <Button
                                            variant="warning"
                                            onClick={() => setOpenUpdateStatusItemModal(false)}
                                            style={{
                                                outline: "none",
                                                border: "none",
                                            }}
                                        >
                                            Close
                                        </Button>
                                        <Button type="submit">
                                            {isItemStatusBtnLoading ? (
                                                <Spinner size="sm" />
                                            ) : (
                                                "UPDATE"
                                            )}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        )}

                        {openEditStatusWithRemarksModal && (
                            <Modal
                                show={openEditStatusWithRemarksModal}
                                onHide={() => setOpenEditStatusWithRemarksModal(false)}
                                centered
                                aria-labelledby="vertically-centered-modal"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="vertically-centered-modal" className="fs-6">
                                        UPDATE STATUS OF THE PROCUREMENT
                                    </Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={handleEditStatusWithRemarksSubmit}>
                                    <Modal.Body>
                                        <p>
                                            Are you sure you want to update the status of this
                                            procurement?
                                        </p>

                                        <div className="mb-3 mt-4">
                                            <Form.Label>Remark</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={4}
                                                onChange={(e) => {
                                                    setRemark(e.target.value);
                                                    setValidateRemark("");
                                                }}
                                            />
                                            <div className="text-danger">{validateRemark}</div>
                                        </div>

                                        {/* Storage Location Field */}
                                        <Col md={12} className="mt-1">
                                            <Form.Label className="fw-semibold text-muted">
                                                Select Storage Location{" "}
                                                <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Select
                                                components={animatedComponents}
                                                id="selectField"
                                                name="storage_location"
                                                value={storageLocationList
                                                    .map((storage) => ({
                                                        value: storage?._id,
                                                        label: `${storage?.name} -> ${storage?.city}, ${storage?.state}`,
                                                    }))
                                                    .find(
                                                        (option) =>
                                                            option.value === selectedStorageLocation,
                                                    )}
                                                onChange={(selectedOption) =>
                                                    setSelectedStorageLocation(
                                                        selectedOption ? selectedOption.value : "",
                                                    )
                                                }
                                                options={storageLocationList.map((storage) => ({
                                                    value: storage?._id,
                                                    label: `${storage?.name} -> ${storage?.city}, ${storage?.state}`,
                                                }))}
                                                placeholder="Select a Storage Location"
                                                isClearable
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        borderColor: selectedStorageLocation
                                                            ? base.borderColor
                                                            : "red",
                                                    }),
                                                }}
                                            />
                                            {!selectedStorageLocation && (
                                                <span
                                                    className="text-danger d-block"
                                                    style={{ fontSize: "13px" }}
                                                >
                                                    Storage location is required.
                                                </span>
                                            )}
                                        </Col>
                                    </Modal.Body>

                                    <Modal.Footer>
                                        <Button
                                            variant="danger"
                                            onClick={() => setOpenUpdateStatusModal(false)}
                                            style={{
                                                outline: "none",
                                                border: "none",
                                            }}
                                        >
                                            Close
                                        </Button>
                                        <Button type="submit">
                                            {isEditwithRemarkBtnLoading ? (
                                                <Spinner size="sm" />
                                            ) : (
                                                "UPDATE"
                                            )}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        )}

                        {/* Add Material Modal */}
                        {showAddModal && (
                            <Modal
                                show={showAddModal}
                                onHide={() => {
                                    setShowAddModal(false);
                                    resetForm()
                                }
                                }
                                size="lg"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>ADD NEW RAW MATERIAL</Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={addMaterial}>
                                    <Modal.Body>
                                        <Row className="mb-3">
                                            <Col md={6}>
                                                <Form.Group controlId="formMainCategory" className="mb-3">
                                                    <Form.Label className='fw-semibold'>Main Category <span className="text-danger">*</span></Form.Label>
                                                    <Select
                                                        options={mainCategoryOptions}
                                                        value={mainCategoryOptions.find(opt => opt.value === formData.mainCategory)}
                                                        onChange={(selected) => handleSelectChange(selected, 'mainCategory')}
                                                        isClearable
                                                        isSearchable
                                                        placeholder="Select main category"
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group controlId="formSubCategory" className="mb-3">
                                                    <Form.Label className='fw-semibold'>Sub Category</Form.Label>
                                                    <Select
                                                        options={subCategoryOptions}
                                                        value={subCategoryOptions.find(opt => opt.value === formData.subCategory)}
                                                        onChange={(selected) => handleSelectChange(selected, 'subCategory')}
                                                        isClearable
                                                        isSearchable
                                                        placeholder="Select sub category"
                                                        isDisabled={!formData.mainCategory}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md={6}>
                                                <Form.Group controlId="formName" className="mb-3">
                                                    <Form.Label className='fw-semibold'>Name <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="name"
                                                        value={formData.name}
                                                        onChange={handleFormChange}
                                                        placeholder="Enter material name"
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group controlId="formUnit" className="mb-3">
                                                    <Form.Label className='fw-semibold'>Unit <span className="text-danger">*</span></Form.Label>
                                                    <Form.Select
                                                        name="unit"
                                                        value={formData.unit}
                                                        onChange={handleFormChange}
                                                        required
                                                    >
                                                        <option value="">Select unit</option>
                                                        <option value="LITRES">LITRES</option>
                                                        <option value="ML">ML</option>
                                                        <option value="GRAMS">GRAMS</option>
                                                        <option value="KILOGRAMS">KILOGRAMS</option>
                                                        <option value="PACKETS">PACKETS</option>
                                                        <option value="PCS">PCS</option>
                                                        <option value="BOX">BOX</option>
                                                        <option value="NOS">NOS</option>
                                                        <option value="MM">MM</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md={6}>
                                                <Form.Group controlId="formHSN" className="mb-3">
                                                    <Form.Label className='fw-semibold'>HSN Code <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="hsn"
                                                        value={formData.hsn}
                                                        onChange={handleFormChange}
                                                        placeholder="Enter HSN code"
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group controlId="formTax" className="mb-3">
                                                    <Form.Label className='fw-semibold'>Tax Percentage <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="taxPercent"
                                                        value={formData.taxPercent}
                                                        onChange={handleFormChange}
                                                        min="0"
                                                        max="100"
                                                        placeholder="Enter tax percentage"
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col>
                                                <Form.Group controlId="formUnit" className="mb-3">
                                                    <Form.Label className='fw-semibold'>Purchase Unit <span className="text-danger">*</span></Form.Label>
                                                    <Form.Select
                                                        name="purchaseUnit"
                                                        value={formData.purchaseUnit}
                                                        onChange={handleFormChange}
                                                        required
                                                    >
                                                        <option value="">Select purchase unit</option>
                                                        <option value="FOOD">Food</option>
                                                        <option value="BEVERAGE">Beverage</option>
                                                        <option value="CENTRAL">Central</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group controlId="formReorder" className="mb-3">
                                                    <Form.Label className='fw-semibold'>Re-Order Level</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="reOrderLevel"
                                                        value={formData.reOrderLevel}
                                                        onChange={handleFormChange}
                                                        min="0"
                                                        placeholder="Enter re-order level"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col>
                                                <Form.Group controlId="formDescription" className="mb-3">
                                                    <Form.Label className='fw-semibold'>Description <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        name="description"
                                                        value={formData.description}
                                                        onChange={handleFormChange}
                                                        placeholder="Enter description"
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => setShowAddModal(false)}>
                                            Cancel
                                        </Button>
                                        <Button variant="warning" type="submit" disabled={isLoading}>
                                            {isLoading ? (
                                                <>
                                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                    <span className="ms-2">Adding...</span>
                                                </>
                                            ) : (
                                                "Add Material"
                                            )}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        )}

                    </div>

                    {/* Render the Add Purchase Modal */}
                    {renderAddPurchaseModal()}
                </Container>
            </div>
        </React.Fragment>
    );
};

export default PurchaseList;
